import React from 'react';
import PropTypes from 'prop-types';

import { checkClientVersion } from '@apricityhealth/web-common-lib/utils/checkClientVersion';
import AIAgent from '@apricityhealth/web-common-lib/components/AIAgent';
import { Maintenance } from '@apricityhealth/web-common-lib/components/Maintenance';
import { Logger } from '@apricityhealth/web-common-lib';
import { ConversationView } from '@apricityhealth/web-common-lib/views/ConversationView';
import getErrorMessage from '@apricityhealth/web-common-lib/utils/getErrorMessage';
import { AxiosRequest } from '@apricityhealth/web-common-lib/utils/Axios';
import Config from '@apricityhealth/web-common-lib/Config';
import LoginView from '@apricityhealth/web-common-lib/views/LoginView';
//import LoginView from './views/LoginView';

import { SelectSelf } from './components/SelectSelf';
import { CreateAccountDialog } from './dialogs/CreateAccountDialog';
import { TermsDialog } from './dialogs/TermsDialog';
import { EodDialog } from './dialogs/EodDialog';

import { DashboardView, isVisible, isDisabled, getSettings } from './views/DashboardView';
import { ConsolidatedHealthCallbackView } from './views/ConsolidatedHealthCallbackView';

import { SurveyView } from './views/SurveyView';
import { TrialsView } from './views/TrialsView';
import { SettingsView } from './views/SettingsView';
import { ProfileView } from './views/ProfileView';
import { ClearanceView } from './views/ClearanceView';
import { VideoChatView } from './views/VideoChatView';
import { MessagesView } from './views/MessagesView';
import { ReportView } from './views/ReportView';
import { AppointmentsView } from './views/AppointmentsView';
import { FeedbackView } from './views/FeedbackView';
import { ContentView } from './views/ContentView';
import { VaccinationsView } from './views/VaccinationsView';
import CovidTestsView from './views/CovidTestsView';
import { EducationView } from './views/EducationView';
import { WebView } from './views/WebView';
import { HistoryView } from './views/HistoryView';
import { MedicationsView } from 'views/MedicationsView';

import { getTheme } from './themes/manifest';
import * as tokens from './tokens';
import { HotSpotsView } from './views/HotSpotsView';

import ApricityCareLogo from './apricityCareLogo.png';
import ApricityWorkLogo from './apricityWorkLogo.png';
import AndroidStoreImage from './android.png';
import iOSStoreImage from './ios.png';
import GoogleImage from './google.png';
import AppleImage from './apple.png';
import OPNImage from './opn.png';
import AzureImage from './azure.png';

import DashboardIcon from '@material-ui/icons/Dashboard';
import EducationIcon from '@material-ui/icons/OndemandVideo';
import ConversationIcon from '@material-ui/icons/VerifiedUser';
import SurveysIcon from '@material-ui/icons/Poll';
import TrialsIcon from '@material-ui/icons/Poll';
import SettingsIcon from '@material-ui/icons/Settings';
import ProfileIcon from '@material-ui/icons/Person';
import SignOutIcon from '@material-ui/icons/ExitToApp';
import VideoIcon from '@material-ui/icons/Videocam';
import MessagesIcon from '@material-ui/icons/Email';
import ReportIcon from '@material-ui/icons/Description';
import AppointmentsIcon from '@material-ui/icons/Today';
import NavigationMenu from '@material-ui/icons/Menu';
import CallIcon from '@material-ui/icons/Call';
import HomeIcon from '@material-ui/icons/Home';
import FAQIcon from '@material-ui/icons/Assignment';
import FeedbackIcon from '@material-ui/icons/Feedback';
//import PersonIcon from '@material-ui/icons/Person';
import WebIcon from '@material-ui/icons/Web';
import ClearanceIcon from '@material-ui/icons/ClearAll';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import SunIcon from '@material-ui/icons/WbSunny';
import VaccinationIcon from '@material-ui/icons/HowToReg';
import ScheduleRoundedIcon from '@material-ui/icons/ScheduleRounded';
import CheckInIcon from '@material-ui/icons/VerifiedUser';
import AddBoxIcon from '@material-ui/icons/AddBox';
import NetworkCheckIcon from '@material-ui/icons/NetworkCheck';
import PinDropRoundedIcon from '@material-ui/icons/PinDropRounded';
import HistoryIcon from '@material-ui/icons/HistoryTwoTone';
import MedicationsIcon from '@material-ui/icons/LocalPharmacy';

import { blue } from '@material-ui/core/colors';

import { toBoolean, hexToRgba, getClientId } from './utils';

import PWAPrompt from 'react-ios-pwa-prompt'
import IdleTimer from 'react-idle-timer';
import Moment from 'moment-timezone';
import Phone from 'phone';

import 'moment/locale/fr.js';
import 'moment/locale/es.js';
import 'moment/locale/zh-cn.js';
import 'moment/locale/zh-tw.js';

import { languages } from '@apricityhealth/web-common-lib/components/SelectLanguage';

import T from 'i18n-react';
import _ from 'lodash';

import {
    withStyles,
    DialogActions,
    DialogTitle,
    DialogContentText,
    DialogContent,
    Dialog,
    Button,
    AppBar,
    Toolbar,
    IconButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Drawer,
    MenuList,
    ClickAwayListener,
    Divider,
    Paper,
    CircularProgress,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    Badge,
    Snackbar,
    SnackbarContent,
    TextField
} from '@material-ui/core';

import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { Switch, Route, Redirect, Link, NavLink } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

import './App.css';
import { addActivity } from '@apricityhealth/web-common-lib/utils/Services';
import { getComponent } from '@apricityhealth/web-common-lib/dialogs/componentRegistry';
import { SubscriptionDialog } from 'dialogs/SubscriptionDialog';
import { ReminderDialog } from 'dialogs/ReminderDialog';
import { TutorialDialog } from 'dialogs/TutorialDialog';

const log = new Logger();
const CLIENT_VERSION = require('../package.json').version;
const DEFAULT_CONFIG = require('./configs/common/patientConfig.json');
const DEFAULT_LANGUAGE = 'en-us';

log.update({ clientName: 'patient-web-client', clientVersion: CLIENT_VERSION });

// ms, sec, min
const IDLE_TIMEOUT_MS = (Config.stage === 'local' || Config.stage === 'develop') ? 1000 * 60 * 60 : 1000 * 60 * 15;
const LOG_TIMEOOUT_MS = 5 * 1000;

const LOGO_OVERRIDES = [
    {
        override: "Apricity@Work",
        planIds: ["63575a2f-2c1e-4e2f-a0e2-a908a1ae0354", "f318684a-71c9-4e52-af2b-f58205c43f55"]
    },
    {
        override: "ApricityCare"
    }
];

const FEDERATED_LOGINS = {
    "Google": {
        visible: true,
        enabled: true,
        icon: GoogleImage,
        alt: 'Sign in with Google',
        signInPath: (redirect_uri, client_id) => {
            return `/oauth2/authorize?identity_provider=Google&response_type=CODE&client_id=${client_id}&scope=email+openid+phone&redirect_uri=${encodeURIComponent(redirect_uri)}`;
        }
    },
    "Apple": {
        visible: true,
        enabled: true,
        icon: AppleImage,
        alt: 'Sign in with Apple',
        signInPath: (redirect_uri, client_id) => {
            return `/oauth2/authorize?identity_provider=SignInWithApple&response_type=CODE&client_id=${client_id}&scope=email+openid+phone&redirect_uri=${encodeURIComponent(redirect_uri)}`;
        }
    },
    "OPN": {
        visible: Config.stage !== 'production' && Config.stage !== 'staging',               // hide on customer-facing stages (production, staging) for now until we are done testing
        enabled: true,
        icon: OPNImage,
        alt: 'Sign in with OPN',
        signInPath: (redirect_uri, client_id) => {
            return `/oauth2/authorize?identity_provider=OPN&response_type=CODE&client_id=${client_id}&scope=openid%20email%20phone&redirect_uri=${encodeURIComponent(redirect_uri)}`;
        }
        // https://opnhcexternaldev.ciamlogin.com/10f9a4b5-1ce5-4eb5-bf77-1e1fdcb71db5/.well-known/openid-configuration
    },
    "Azure": {
        visible: Config.stage !== 'production' && Config.stage !== 'staging',               // hide on customer-facing stages (production, staging) for now until we are done testing
        enabled: true,
        icon: AzureImage,
        alt: 'Sign in with Microsoft',
        signInPath: (redirect_uri, client_id) => {
            return `/oauth2/authorize?identity_provider=azure&response_type=CODE&client_id=${client_id}&scope=openid%20email%20phone&redirect_uri=${encodeURIComponent(redirect_uri)}`;
        }
        // https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration
    },
    "Facebook": {
        visible: false,
        enabled: false,
        icon: 'facebook.png',
        alt: 'Sign in with Facebook',
    },
    "Amazon": {
        visible: false,
        enabled: false,
        icon: 'amazon.png',
        alt: 'Sign in with Amazon',
    }
};

const NATIVE_LINKS = [
    {
        "url": "https://play.google.com/store/apps/details?id=com.apricityhealth.apricityatwork",
        "device": "android",
        "planIds": ["63575a2f-2c1e-4e2f-a0e2-a908a1ae0354", "f318684a-71c9-4e52-af2b-f58205c43f55"]
    },
    {
        "url": "https://itunes.apple.com/us/app/apricitycare/id1521331738",
        "device": "ios",
        "planIds": ["63575a2f-2c1e-4e2f-a0e2-a908a1ae0354", "f318684a-71c9-4e52-af2b-f58205c43f55"]
    },
    // default links for all other plans
    {
        "url": "https://play.google.com/store/apps/details?id=com.apricityhealth.patient",
        "device": "android"
    },
    {
        "url": "https://itunes.apple.com/us/app/apricitycare/id1436081572",
        "device": "ios"
    }
];

function getQuery() {
    return new URLSearchParams(window.location.search);
}

function getAppName() {
    // prefer the query parameter over local storage at all times...
    let appName = getQuery().get('appName');
    if (!appName) {
        appName = localStorage.getItem('appName');
        if (!appName) {
            // last resort, just check the stage and default to either ApricityCare for all env's except for production..
            appName = "ApricityCare";
        }
    } else {
        localStorage.setItem('appName', appName);
    }
    return appName;
}

function isHTML(str) {
    return str.indexOf('<br>') >= 0 || str.indexOf('<ul>') >= 0 || str.indexOf('<p>') >= 0;
}

function isReactNative() {
    return window.ReactNativeWebView ? true : false;
}

function isArrayValid(array) {
    return Array.isArray(array) && array.length > 0;
}

function getHostPrefix() {
    let host = window.location.host;
    let colon = host.indexOf(':');
    if (colon >= 0)
        host = host.substring(0, colon);
    let dot = host.indexOf('.');
    if (dot >= 0)
        host = host.substring(0, dot);
    return host;
}

class IdleDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countDown: 60
        };
    }

    componentDidMount() {
        this.intervalTimer = setInterval(() => {
            let { countDown } = this.state;
            countDown -= 1;
            if (countDown < 0)
                this.props.appContext.confirmSignOut();
            else
                this.setState({ countDown });
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.intervalTimer);
    }

    onCancel() {
        this.props.appContext.setState({ idleDialog: null });
    }

    render() {
        let { countDown } = this.state;
        return <Dialog id="idleTimeout" open={true} onClose={this.onCancel.bind(this)} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
            <DialogContent>
                <T.span text={{ key: 'idleTimeout', countDown }} />
            </DialogContent>
            <DialogActions>
                <Button color="primary" variant="contained" onClick={this.onCancel.bind(this)}><T.span text='cancel' /></Button>
            </DialogActions>
        </Dialog>
    }
}

class App extends React.Component {
    constructor(props) {
        super(props);

        log.debug("stage:", Config.stage);

        const timezone = Moment.tz.guess();
        log.debug("timezone:", timezone);

        Moment.updateLocale("es", { week: { dow: 0 } })
        Moment.updateLocale("fr", { week: { dow: 0 } })

        let language = localStorage.getItem('language') || (navigator.languages && navigator.languages[0])
            || navigator.language || navigator.userLanguage;
        language = language.toLowerCase();      // normalize to lower-case
        if (!languages[language]) {
            language = DEFAULT_LANGUAGE;         // not in our list of supported languages, fallback to the default language
        }

        Moment.locale(language);

        log.debug("language:", language);
        let temperatureUnit = localStorage.getItem('temperatureUnit') || 'F';
        log.debug("temperatureUnit:", temperatureUnit);

        this.appTexts = {};
        this.appTexts[language] = require(`./locale/${language}.json`);

        // when ?models=A,B,C is in the URL, auto-start a check-in for those models once the user is authenticated.
        // this lets a provider send a link that drops the patient straight into a specific test (e.g. PHQ-4).
        const search = new URLSearchParams(window.location.search);
        const modelsParam = search.get('models');
        const models = modelsParam ? modelsParam.split(',').map((m) => m.trim()).filter(Boolean) : null;
        // when ?openComponent=<Name> is in the URL, auto-open the registered dialog once the user is authenticated.
        const openComponent = (search.get('openComponent') || '').trim() || null;

        this.state = {
            version: CLIENT_VERSION,
            username: '',
            idToken: null,
            refreshToken: null,
            currentView: null,
            menu: false,
            dialog: null,
            openDialog: null,
            patient: null,
            lastBaseline: null,
            patientId: '',
            models: models && models.length ? models : null,
            openComponent,
            theme: localStorage.getItem('theme') || null,
            language,
            temperatureUnit,
            timezone,
            registerDone: false,
            domainDetected: false,
            termsAccepted: false,
            config: {},
            textLoaded: false,
            configLoaded: false,
            leftNavOpen: false,
            alertLevelsLoaded: false,
            alertLevels: [],
            domainOrg: null,
            defaultProviderId: '',
            defaultPlanId: Config.defaultPlanId,
            faq: [],
            companyPolicy: [],
            tutorials: [],
            isReactNative: isReactNative(),
            biometricLoginEnabled: false,
            contactTracingEnabled: false,
            lastSessionId: '',
            cache: {},
            surveys: [],
            messageCount: 0,
            hideMessages: false,
            hideSubscribeSnackbar: false,
            hideReminderSnackbar: false,
            hideSurveySnackbar: false,
            forcedCheckInReminderMessage: false,
            subscriptionId: '',
            removeAccount: false,
            removeAccountConfirmation: '',
        }
    }

    isMobile()  { return window.innerWidth < 768; }
    isTablet()  { return window.innerWidth >= 768 && window.innerWidth < 1200; }
    isDesktop() { return window.innerWidth >= 1200; }

    // Alias for backward compatibility — existing callers (dialog fullScreen,
    // mobile-only branches) get the new mobile breakpoint via this method.
    isCompactDisplay() { return this.isMobile(); }

    unhandledError = (event) => {
        log.error("Unhandled error:", event );
        event.preventDefault();
    }

    unhandledRejection = (event) => {
        log.error("Unhandled rejection:", event);
        event.preventDefault();
    }

    componentDidMount() {
        let { defaultPlanId, defaultProviderId } = this.state;

        // register a global error handler to catch any unhandled errors or promises, for now we will just log those errors
        window.addEventListener("error", this.unhandledError );
        window.addEventListener("unhandledrejection", this.unhandledRejection);

        // check our client version against the back-end, this should reload this client if needed.
        checkClientVersion().then(() => {
            const query = getQuery();

            const hostPrefix = getHostPrefix();
            const thisUrl = window.location.protocol + '//' + window.location.host;
            if (thisUrl !== Config.patientClientUrl && Config.stage !== 'local' && hostPrefix !== 'localhost') {
                query.set('hostPrefix', hostPrefix);
                // open the actual client URL, pass in the hostPrefix so we can look up the domain org.. 
                window.location.href = Config.patientClientUrl + '?' + query.toString();
            } else {
                const removeAccount = toBoolean(query.get('removeAccount'))
                const subscriptionId = query.get("subscriptionId");
                if (subscriptionId) {
                    this.setState({ subscriptionId, patientId: query.get("patientId") });
                }

                if ( query.get("action") ) {
                    const message = {};
                    query.forEach((value,key) => message[key] = value);
                    log.debug("posting action message to parent window:", message );
                    this.postParentMessage(message);
                }

                const hostPrefix = query.get('hostPrefix') || localStorage.getItem('hostPrefix') || getHostPrefix();
                localStorage.setItem('hostPrefix', hostPrefix);            // keep using the same hostprefix until they provide a new one

                const getDomainOrg = {
                    url: Config.baseUrl + `${Config.pathPrefix}anon/orgs/domain/${hostPrefix}`,
                    method: 'GET',
                    maxAttempts: 0      // don't retry on this call, if the back-end is down we don't want to take forever with a blank screen
                };
                log.debug("getDomainOrg request:", getDomainOrg);
                AxiosRequest(getDomainOrg).then((response) => {
                    let domainOrg = isArrayValid(response.data) && response.data[0];
                    log.debug("getDomainOrg response:", response.data);
                    if (!domainOrg) throw new Error("No domain org!");
                    let defaultPlan = domainOrg.planIds ? domainOrg.planIds.find((e) => e.default === true) : null;
                    if (defaultPlan)
                        defaultPlanId = defaultPlan.planId;
                    if (domainOrg.defaultProviderId)
                        defaultProviderId = domainOrg.defaultProviderId;
                    if (domainOrg.name) {
                        localStorage.setItem("appName", domainOrg.name );
                    }
                    document.title = getAppName();
                    let androidLink = NATIVE_LINKS.find((e) => {
                        return e.device === 'android' && (!Array.isArray(e.planIds) || e.planIds.indexOf(defaultPlanId) >= 0);
                    });
                    let iosLink = NATIVE_LINKS.find((e) => {
                        return e.device === 'ios' && (!Array.isArray(e.planIds) || e.planIds.indexOf(defaultPlanId) >= 0);
                    });
                    if (domainOrg.customLogo) {
                        log.debug("Setting logoOverride:", domainOrg.customLogo);
                        localStorage.setItem("logoOverride", domainOrg.customLogo);
                    }
                    let { theme } = this.state;
                    if (!theme && domainOrg.config?.themeOverride) {
                        theme = domainOrg.config?.themeOverride;
                        localStorage.setItem("theme", theme);
                    }
                    // } else if (!localStorage.getItem("logoOverride")) {
                    //     let logoOverride = LOGO_OVERRIDES.find((e) => {
                    //         return !Array.isArray(e.planIds) || e.planIds.indexOf(defaultPlanId) >= 0;
                    //     });
                    //     if (logoOverride) {
                    //         log.debug("Setting logoOverride:", logoOverride.override);
                    //         localStorage.setItem("logoOverride", logoOverride.override);
                    //     }
                    // }

                    log.info(`defaultPlanId: ${defaultPlanId}, defaultProviderId: ${defaultProviderId}, domainOrg:`, domainOrg);
                    this.setState({ theme, removeAccount, domainDetected: true, defaultPlanId, defaultProviderId, domainOrg, androidLink, iosLink }, this.checkRegistrationCode.bind(this))
                }).catch((err) => {
                    log.info("getDomainOrg error:", err);
                    this.setState({ removeAccount, domainDetected: true }, this.checkRegistrationCode.bind(this));
                })
            }

        }).catch((err) => {
            log.error("checkClientVersion error:", err);
        });


        this.registerMessageHandler(this.onMessage);
        window.addEventListener('resize', this.onHandleResize);
    }

    checkRegistrationCode() {
        const query = getQuery();
        if (query.get('registrationCode') || toBoolean(query.get('iframe')))      // remove the check for iFrame to open the register page, we need that flag for the forgot password page as well
            this.onRegister();                  // open the register dialog automatically when there is a registration code
    }

    onHandleResize = () => {
        if (this.isCompactDisplay()) {
            this.setState({ menu: false, leftNavOpen: false });       // hide the menu
        } else {
            this.setState({ menu: true, leftNavOpen: true });         // show the menu
        }
    }

    componentWillUnmount() {
        this.unregisterMessageHandler(this.onMessage);
        window.removeEventListener("resize", this.onHandleResize);
        window.removeEventListener("unhandledrejection", this.unhandledRejection);
        window.removeEventListener("error", this.unhandledError );
    }

    postMessage(message) {
        if (isReactNative()) {
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
        }
    }

    postParentMessage(message) {
        if (window.parent) {
            window.parent.postMessage(JSON.stringify(message), '*');
        }
    }

    registerMessageHandler(handler) {
        window.addEventListener('message', handler);
        document.addEventListener('message', handler);
    }

    unregisterMessageHandler(handler) {
        window.removeEventListener('message', handler);
        document.removeEventListener('message', handler);
    }

    onMessage = (message) => {
        try {
            log.debug("onMessage:", message);
            if (typeof message.data === 'string') {
                if (message.data) {
                    let msg = JSON.parse(message.data);
                    if (msg.action) {
                        //log.debug("onMessage:", msg );
                        if (msg.action === 'setEnableBiometricLogin') {
                            this.setState({ biometricLoginEnabled: msg.enabled });
                        }
                        else if (msg.action === 'setContactTracingEnabled') {
                            this.setState({ contactTracingEnabled: msg.enabled });
                        }
                        else if (msg.action === 'idleMinutes') {
                            if ((1000 * 60 * msg.idleMinutes) > IDLE_TIMEOUT_MS)
                                this.confirmSignOut();
                        } else if (msg.action === 'reloadPatient') {
                            // this message is sent by the iframe back to the main app so we know to reload the patient from the back-end
                            this.reloadPatient();
                        } else if (msg.action === 'onLog') {
                            log[msg.logLevel || 'info'](...msg.logs);
                        } else if ( typeof this[msg.action] === 'function' ) {
                            this[msg.action]( msg );
                        }
                    }
                }
            }
        }
        catch (err) {
            log.warning("onMessage error:", err, message);
        }
    }

    // sent by the RN shell (apricity-care / apricity-at-work) when a deep link is received while the app is already
    // running. msg.models is either an array or a comma-separated string. mirrors the initial-launch ?models= flow.
    startCheckin = (msg) => {
        let models = msg && msg.models;
        if (typeof models === 'string') models = models.split(',').map((m) => m.trim()).filter(Boolean);
        if (!Array.isArray(models) || !models.length) return;
        log.info("startCheckin received models:", models);
        this.setState({ models }, () => {
            const { idToken, patientId, termsAccepted, configLoaded, textLoaded, alertLevelsLoaded } = this.state;
            // if the user is already past the loading gate, redirect now; otherwise onSelfSelected will pick up state.models after login completes.
            if (idToken && patientId && termsAccepted && configLoaded && textLoaded && alertLevelsLoaded) {
                this.setState(
                    { dialog: <Redirect to='/conversation' /> },
                    () => this.setState({ dialog: null })
                );
            }
        });
    }

    getSelf() {
        // grab our patientId
        const url = Config.baseUrl + `${Config.pathPrefix}patients/self`;
        const getSelf = {
            url: url,
            method: 'GET',
            headers: { "Authorization": this.state.idToken }
        }

        const startTime = Date.now();
        log.debug("getSelf:", url);
        AxiosRequest(getSelf).then((response) => {
            log.info(`getSelf result, ${Date.now() - startTime} ms:`, response.data);
            const patient = response.data;
            if (Array.isArray(patient)) {
                this.setState({
                    progress: null,
                    dialog: <SelectSelf
                        patients={patient}
                        onSelect={(patient) => {
                            if (patient) {
                                this.setState({ dialog: null }, this.onSelfSelected.bind(this, patient));
                            }
                            else {
                                this.setState({ dialog: null, progress: <p>Login cancelled.</p> }, this.confirmSignOut.bind(this));
                            }
                        }} />
                });
            } else {
                if (patient.org && patient.org.inactive) throw Error('inactiveOrg');
                this.onSelfSelected(patient);
            }

        }).catch((error) => {
            const appName = getAppName();
            const otherAppName = appName === 'ApricityCare' ? 'Apricity@Work' : 'ApricityCare';
            log.warning("getSelf error:", error);
            this.setState({
                dialog: <Dialog id="noRecordFound" open={true} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                    <DialogTitle>{error.message === 'inactiveOrg' ? <T.span text='inactiveOrg' /> : <T.span text='noRecordFound' />}</DialogTitle>
                    <DialogContent>{error.message === 'inactiveOrg' ? <T.span text='inactiveOrgMessage' /> : <T.span text={{ key: 'noPatientRecord', appName, otherAppName }} />}</DialogContent>
                    <DialogActions><Button id="noPatientRecordOk" variant='contained' color='primary' onClick={this.confirmSignOut.bind(this)}><T.span text='ok' /></Button></DialogActions>
                </Dialog>
            });
        });

    }

    onSetTheme(theme) {
        localStorage.setItem("theme", theme);
        this.setState({ theme });
    }

    onSetLanguage(language) {
        if (!languages[language]) throw new Error("Unsupported language");
        localStorage.setItem('language', language);
        Moment.locale(language)

        this.updatePatient({ language });
        this.setState({ language }, this.updateLanguage.bind(this));
    }

    updateLanguage() {
        const { language } = this.state

        this.appTexts[language] = require(`./locale/${language}.json`);
        this.postMessage({ action: 'onSetLanguage', language });

        this.getTexts().finally(() => {
            this.getFAQ()
            this.getCompanyPolicy();
            this.refreshMenu();
        });
    }

    onSetTemperatureUnit(unit) {
        if (unit !== 'F' && unit !== 'C') throw new Error("Unsupported temperatureUnit");
        localStorage.setItem("temperatureUnit", unit);
        this.setState({ temperatureUnit: unit });
    }

    getPlanIds(patient) {
        return patient && Array.isArray(patient.plans) ? patient.plans.map((e) => e.planId) : [];
    }

    getCountry(patient) {
        if (patient) {
            let address = patient.address.find((e) => e.country !== undefined);
            if (address) return address.country;
        }
        return 'US';        // default to United States
    }

    onSelfSelected(patient) {
        log.debug(`onSelfSelected, patientId: ${patient.patientId}:`, patient);
        const { userId } = this.state;
        const { patientId, provider, org, user, gender, lastBaseline, planModels } = patient;
        const providerPhones = provider ? provider.phoneNumbers : [];
        let orgContact = org ? org.contacts.find((e) => e.contactId === 'default') : null;
        if (org && !orgContact && org.contacts.length > 0)
            orgContact = org.contacts[0];       // no default contact found, just use the first contact then..
        const orgPhones = orgContact ? orgContact.phoneNumbers : [];
        const userType = patient.userId === userId ? 'patient' : 'delegate';
        log.info(`userType: ${userType}, userId: ${userId}, patient.userId: ${patient.userId}`);

        //patient.reminderEnabled = undefined;           // uncomment to debug SMS reminder

        // update the logoOverride based on the default plan of the org
        if (org.customLogo) {
            log.debug("Setting logoOverride:", org.customLogo);
            localStorage.setItem("logoOverride", org.customLogo);
        } else {
            let defaultPlan = org && org.planIds ? org.planIds.find((e) => e.default === true) : null;
            if (defaultPlan) {
                let defaultPlanId = defaultPlan.planId;
                let logoOverride = LOGO_OVERRIDES.find((e) => {
                    return !Array.isArray(e.planIds) || e.planIds.indexOf(defaultPlanId) >= 0;
                });
                if (logoOverride) {
                    log.debug("Setting logoOverride:", logoOverride.override);
                    localStorage.setItem("logoOverride", logoOverride.override);
                }
            }
        }
        let { theme } = this.state;
        if (!theme && org.config?.themeOverride) {
            theme = org.config.themeOverride;
            localStorage.setItem('theme', theme);
        }
        let planActive = (patient.plans || []).reduce((p, c) => {
            const plan = (planModels || []).find((e) => e.planId === c.planId);
            if (plan && plan.inactive) {
                return p;
            }
            if (!c.startDate || Moment(c.startDate) < Moment()) {
                if (!c.endDate || Moment(c.endDate) > Moment()) {
                    return true;
                }
            }
            return p;
        }, false);
        log.debug("planActive:", planActive, patient.plans, planModels);

        if (org && org.enableMFA && !user.mfaEnabled) {
            user.mfaEnabled = true;
            saveUser(this.state.idToken, user).then((result) => {
                log.debug("MFA enabled for user account:", user);
            }).catch((err) => {
                log.error("Error enabling MFA for account:", user);
            });
        }

        log.debug("Setting providerLoaded/orgLoaded to true");
        this.setState({
            patientId,
            userType,
            gender,
            patient,
            planModels,
            planActive,
            lastBaseline,
            user,
            account: user,          // TODO: account is deprecated, remove it slowly over time and use user instead
            provider,
            providerPhones,
            providerLoaded: true,
            org,
            orgPhones,
            orgLoaded: true,
            theme,
            cache: {}
        }, () => {
            let startTime = Date.now();
            this.updatePatient({
                previousLogin: patient.lastLogin,
                lastLogin: new Date(),
                loginCount: (patient.loginCount || 0) + 1
            });

            Promise.all([
                this.getTexts(),
                this.getAlertLevels(),
                this.getConfig(),
                this.getPatientSurveys(),
                this.getPatientTrials(),
                this.getTutorials()
            ]).then(() => {
                log.debug(`Loaded text, provider, org, config, and alerts in ${Date.now() - startTime} ms`);
                this.displayTermsDialog();
                return Promise.all([this.getFAQ(), this.getCompanyPolicy()]);
            }).then(() => {
                this.refreshMenu();

            }).catch((err) => {
                const message = getErrorMessage(err);
                log.error("onSelfSelected error:", message);
                this.setState({
                    dialog: <Dialog id="appError" open={true} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                        <DialogTitle><T.span text='clientErrorTitle' /></DialogTitle>
                        <DialogContent><T.span text={{ key: 'clientError', message }} /></DialogContent>
                        <DialogActions><Button id="noPatientRecordOk" variant='contained' color='primary' onClick={this.confirmSignOut.bind(this)}><T.span text='ok' /></Button></DialogActions>
                    </Dialog>
                });
            })
        })
    }

    displayTermsDialog() {
        log.debug("displayTermsDIalog()");
        const { org, patient, config, language, planActive } = this.state;
        let dialog = planActive ?
            isArrayValid(config.termIds) ? <TermsDialog
                appContext={this}
                patient={patient}
                org={org}
                planIds={this.getPlanIds(patient)}
                termIds={config.termIds}
                language={language}
                country={this.getCountry(patient)}
                onAccepted={this.onAcceptedTerms.bind(this)}
                onRejected={this.onRejectedTerms.bind(this)} />
                : null
            : <Dialog open={true}>
                <DialogTitle><T.span text='noPlan' /></DialogTitle>
                <DialogContent><T.span text="noPatientPlans" /></DialogContent>
                <DialogActions>
                    <Button variant='contained' color="primary" onClick={this.onAcceptedTerms.bind(this)}><T.span text='ok' /></Button>
                </DialogActions>
            </Dialog>;

        if (dialog !== null) {
            this.setState({
                progress: null,
                dialog
            });
        } else {
            this.onAcceptedTerms();
        }
    }

    getTexts() {
        log.debug("getTexts()");
        const startTime = Date.now();
        return new Promise((resolve, reject) => {
            const { patient, idToken, language } = this.state
            let planIds = this.getPlanIds(patient);
            let promises = []
            planIds.forEach((planId) => {
                let cacheKey = `texts.${planId}.${language}`;
                let cached = localStorage.getItem(cacheKey);
                if (cached) {
                    cached = JSON.parse(cached);
                    if (cached.version === CLIENT_VERSION) {
                        promises.push(cached.data);
                    } else {
                        cached = null;      // old version, do a new request to the back-end
                    }
                }
                if (!cached) {
                    const request = {
                        url: Config.baseUrl + `${Config.pathPrefix}content/text?planId=${planId}&category=common,patient.web&dependencies=true&language=${language}`,
                        method: 'GET',
                        headers: { "Authorization": idToken }
                    }
                    log.debug("getTexts:", request);
                    promises.push(AxiosRequest(request).then((result) => {
                        localStorage.setItem(cacheKey, JSON.stringify({ version: CLIENT_VERSION, data: result.data.text }));
                        return result.data.text;
                    }));
                }
            })

            Promise.all(promises).then((results) => {
                log.debug(`getTexts results, ${Date.now() - startTime} ms:`, results);
                if (this.appTexts[language] === undefined)
                    this.appTexts[language] = {};

                results.forEach((result) => {
                    for (let i = 0; i < result.length; ++i) {
                        let text = result[i];
                        this.appTexts[language][text.textId] = text.text;
                    }
                });

                const { org } = this.state;
                if ( org && org.config && org.config["textOverrides"]) {
                    try {
                        const textOverrides = JSON.parse(org.config["textOverrides"]);
                        if ( Array.isArray(textOverrides)) {
                            log.info("Applying Org textOverrides:", textOverrides );
                            textOverrides.forEach((override) => {
                                this.appTexts[override.language][override.textId] = override.text;
                            });
                        }
                    } catch(err) {
                        log.warning("Failed to parse org.config.textOverrides:", err );
                    }
                }
                log.debug("Setting textLoaded to true");
                this.setState({ textLoaded: true }, resolve);
            }).catch((err) => {
                log.error("getTexts error:", err);
                setTimeout(() => this.getTexts().then(resolve).catch(reject), 1000);      // re-try in 1 second
            })
        })
    }

    getFAQ() {
        const startTime = Date.now();
        return new Promise((resolve, reject) => {
            let planIds = this.getPlanIds(this.state.patient);
            log.debug("planIds:", planIds);
            if (planIds.length > 0) {
                const { org, language } = this.state;
                let faqTextId = _.get(org, "config.faqTextId") || 'faq';
                let cacheKey = `faq.${faqTextId}.${language}.${planIds.join(',')}`;
                let cached = localStorage.getItem(cacheKey);
                if (cached) {
                    cached = JSON.parse(cached);
                    if (cached.version === CLIENT_VERSION) {
                        return this.setState({ faq: cached.data }, resolve);
                    }
                }

                let queryParams = [
                    `textId=${faqTextId}`,
                    `language=${language}`,
                    "planId=" + planIds.join(',')
                ];
                let getFAQ = {
                    url: Config.baseUrl + `${Config.pathPrefix}content/text?` + queryParams.join('&'),
                    method: 'GET',
                    headers: { "Authorization": this.state.idToken },
                }
                log.debug("getFAQ:", getFAQ);
                AxiosRequest(getFAQ).then((response) => {
                    log.debug(`getFAQ result, ${Date.now() - startTime} ms:`, response.data.text);
                    localStorage.setItem(cacheKey, JSON.stringify({ version: CLIENT_VERSION, data: response.data.text }));      // save to local storage and save the call next time
                    this.setState({ faq: response.data.text }, resolve);
                }).catch((err) => {
                    log.error("getFAQ error:", err);
                    setTimeout(() => this.getFAQ().then(resolve).catch(reject), 1000);      // re-try in 1 second
                })
            }
            else {
                resolve();
            }
        });
    }

    getCompanyPolicy() {
        const { language } = this.state;
        const { org } = this.state;

        let companyPolicy = _.get(org, `config.companyPolicyPage_${language}`) || _.get(org, 'config.companyPolicyPage_en-us');
        log.debug("companyPolicy:", companyPolicy);
        if (companyPolicy)
            this.setState({ companyPolicy: [{ text: companyPolicy }] });
    }

    getConfig() {
        log.debug("getConfig()");
        const startTime = Date.now();
        return new Promise((resolve, reject) => {
            let planIds = this.getPlanIds(this.state.patient);
            if (planIds.length > 0) {
                let promises = [];
                if (Config.stage === 'local') {
                    log.info("Using local default config!");
                    promises.push([{ config: JSON.stringify(DEFAULT_CONFIG) }]);
                }
                else {
                    for (let i = 0; i < planIds.length; ++i) {
                        let planId = planIds[i];
                        let cacheKey = `config.${planId}`;
                        let cached = localStorage.getItem(cacheKey);
                        if (cached) {
                            cached = JSON.parse(cached);
                            if (cached.version === CLIENT_VERSION) {
                                promises.push(Promise.resolve(cached.data));
                            } else {
                                cached = null;
                            }
                        }
                        if (!cached) {
                            let getConfig = {
                                url: Config.baseUrl + `${Config.pathPrefix}types/${planId}/configs/patientConfig`,
                                method: 'GET',
                                headers: { "Authorization": this.state.idToken },
                            }

                            log.debug("getConfig:", getConfig);
                            promises.push(AxiosRequest(getConfig).then((result) => {
                                localStorage.setItem(cacheKey, JSON.stringify({ version: CLIENT_VERSION, data: result.data }));
                                return result.data;
                            }));
                        }
                    }
                }

                Promise.all(promises).then((results) => {
                    log.debug(`getConfig results, ${Date.now() - startTime} ms:`, results);
                    let config = {};
                    for (let i = 0; i < results.length; ++i) {
                        let configs = results[i];
                        for (let i = 0; i < configs.length; ++i)
                            _.merge(config, JSON.parse(configs[i].config));
                    }

                    // validate the language we have selected is in the list found in the config.
                    if (config.languages) {
                        if (!config.languages[this.state.language]) {
                            log.warning(`Selected language not found in the config, changing to the default language.`);
                            this.onSetLanguage(DEFAULT_LANGUAGE);
                        }
                    }

                    log.debug("Setting configLoaded to true", config);
                    this.setState({ config, configLoaded: true }, resolve);
                }).catch((err) => {
                    log.error("getConfig error:", err);
                    setTimeout(() => this.getConfig().then(resolve).catch(reject), 1000);      // re-try in 1 second
                })

            }
            else {
                log.debug('No planIds, setting configLoaded to true anyways.');
                this.setState({ configLoaded: true }, resolve);
            }
        })
    }

    getAlertLevels() {
        log.debug("getAlertLevels()");
        const startTime = Date.now();
        return new Promise((resolve, reject) => {
            let planIds = this.getPlanIds(this.state.patient);
            if (planIds.length > 0) {
                let promises = [];
                for (let i = 0; i < planIds.length; ++i) {
                    let planId = planIds[i];
                    let cacheKey = `alerts.${planId}`;
                    let cached = localStorage.getItem(cacheKey);
                    if (cached) {
                        cached = JSON.parse(cached);
                        if (cached.version === CLIENT_VERSION) {
                            promises.push(cached.data);
                        } else {
                            cached = null;
                        }
                    }
                    if (!cached) {
                        let getAlertLevels = {
                            url: Config.baseUrl + `${Config.pathPrefix}types/${planId}/alert_levels/*`,
                            method: 'GET',
                            headers: { "Authorization": this.state.idToken },
                        }
                        log.debug("getAlertLevels:", getAlertLevels);
                        promises.push(AxiosRequest(getAlertLevels).then((result) => {
                            localStorage.setItem(cacheKey, JSON.stringify({ version: CLIENT_VERSION, data: result.data }));
                            return result.data;
                        }));
                    }
                }

                Promise.all(promises).then((results) => {
                    log.debug(`getAlertLevels results, ${Date.now() - startTime} ms:`, results);
                    const alertLevels = results.reduce((p,c) => p.concat(c), []);

                    log.debug("Setting alertLevelsLoaded to true");
                    this.setState({ alertLevels, alertLevelsLoaded: true }, resolve);
                }).catch((err) => {
                    log.error("getAlertLevels error:", err);
                    setTimeout(() => this.getAlertLevels().then(resolve).catch(reject), 1000);      // re-try in 1 second
                })
            }
            else {
                log.debug("Setting alertLevelsLoaded to true");
                this.setState({ alertLevels: [], alertLevelsLoaded: true }, resolve);
            }
        })
    }

    getPatientSurveys() {
        const { idToken, patientId } = this.state;

        return new Promise((resolve, reject) => {
            let getPatientSurveys = {
                url: Config.baseUrl + `${Config.pathPrefix}dialog/surveys/${patientId}`,
                method: 'POST',
                headers: { "Authorization": idToken },
                data: {}
            };

            log.debug("getPatientSurveys:", getPatientSurveys);
            AxiosRequest(getPatientSurveys).then((response) => {
                log.debug("getPatientSurveys result:", response.data);
                this.setState({ surveys: response.data }, () => resolve(response.data));
            }).catch((err) => {
                log.error("getPatientSurveys error:", err);
                reject(err);
            })
        })
    }

    getPatientTrials() {
        const { idToken, patientId } = this.state;

        return new Promise((resolve, reject) => {
            let getPatientTrials = {
                url: Config.baseUrl + `${Config.pathPrefix}trials/patient/${patientId}?all=true`,
                method: 'GET',
                headers: { "Authorization": idToken }
            };

            log.debug("getPatientTrials:", getPatientTrials);
            AxiosRequest(getPatientTrials).then((response) => {
                log.debug("getPatientTrials result:", response.data);
                this.setState({ trials: response.data.patientTrials }, () => resolve(response.data.patientTrials));
            }).catch((err) => {
                log.error("getPatientTrials error:", err);
                reject(err);
            })
        })
    }

    getTutorials() {
        const { idToken, patientId, language } = this.state;
        return new Promise((resolve, reject) => {
            const request = {
                url: Config.baseUrl + `${Config.pathPrefix}content/education/${patientId}?language=${language}&tutorial=true&conditional=true`,
                method: 'GET',
                headers: { "Authorization": idToken },
            }

            log.debug(`getTutorials request`, request);
            AxiosRequest(request).then((response) => {
                log.debug(`getTutorials response`, response.data);
                this.setState({ tutorials: response.data }, () => resolve(response.data));
            }).catch((err) => {
                log.error("getTutorials error:", err);
                reject(err);
            });
        });
    }

    loadBaseline() {
        const { idToken, patientId } = this.state;

        return new Promise((resolve, reject) => {
            let getBaselineJournal = {
                url: Config.baseUrl + `${Config.pathPrefix}journal/${patientId}?baseline=true&limit=1`,
                method: 'GET',
                headers: { "Authorization": idToken },
            };

            log.debug("loadBaseline:", getBaselineJournal);
            AxiosRequest(getBaselineJournal).then((response) => {
                log.debug("loadBaseline result:", response.data);
                let lastBaseline = response.data.records.length > 0 ? response.data.records[0] : null;
                this.setState({ lastBaseline }, () => resolve(lastBaseline));
            }).catch((err) => {
                log.error("loadBaseline error:", err);
                reject(err);
            })
        })
    }

    checkTutorial() {
        const { tutorials } = this.state;

        const activeTutorials = tutorials.filter((e) => {
            if (localStorage.getItem(`tutorial-${e.educationId}-skip`)) {
                return false;
            }
            return true;
        })
        if (activeTutorials.length > 0) {
            let tutorial = activeTutorials[0];
            this.setState({
                dialog: <TutorialDialog appContext={this} tutorial={tutorial}
                    onClose={() => this.setState({ dialog: null }, () => this.checkForcedCheckInReminder())}
                    onDismiss={() => {
                        localStorage.setItem(`tutorial-${tutorial.educationId}-skip`, 'true');
                        this.setState({ dialog: null }, () => this.checkForcedCheckInReminder());
                    }}
                />
            })
        } else {
            this.checkForcedCheckInReminder();
        }
    }

    checkForcedCheckInReminder() {
        const { org } = this.state;
        const forcedCheckInReminder = toBoolean(_.get(org, 'config.forcedCheckInReminder'), false);
        log.debug("checkForcedCheckinReminder:", forcedCheckInReminder);
        if (forcedCheckInReminder) {
            let { patient: { reminderEnabled, reminderTime, reminderInterval, phoneNumbers } } = this.state;
            //reminderEnabled = undefined;        // force on for testing
            log.debug(`reminderEnabled: ${reminderEnabled}, reminderTime: ${reminderTime}, reminderInterval: ${reminderInterval}`);
            if (reminderEnabled === undefined || reminderEnabled === null) {
                const validMobile = (phoneNumbers || []).find((e) => e.numberType === 'mobile' && Phone(e.number).isValid);
                log.debug(`validMobile: ${JSON.stringify(validMobile)}`);
                if (validMobile) {
                    // auto-enable the reminder for the current time and go to the next step
                    //log.debug("Setting forcedCheckInReminderMessage to true.");
                    this.setState({ forcedCheckInReminderMessage: true }, () => {
                        //log.debug("forcedCheckInReminderMessage:", this.state.forcedCheckInReminderMessage );
                    });
                    this.updatePatient({
                        reminderEnabled: true,
                        reminderTime: Moment().add(1, 'week').toDate(),       // default to this current time
                        reminderInterval: (1440 * 7)                                // default to weekly
                    }).then(() => this.checkBaseline());
                } else {
                    // no valid phone number, pop up the dialog directly..
                    this.setState({
                        dialog: <ReminderDialog appContext={this} onSet={() => {
                            this.setState({ dialog: null }, () => this.checkBaseline());
                        }} />
                    })
                }
            } else {
                this.checkBaseline();
            }
        } else {
            this.checkBaseline();
        }
    }

    checkBaseline() {
        const { org } = this.state;
        const { lastBaseline, patient, planActive } = this.state;

        const inConversation = window.location.pathname.endsWith('/conversation');          // we don't display the checkDaily if they are already checking in
        const orgConfig = _.get(org, "config") || {};
        const disableBaselineCheck = toBoolean(_.get(orgConfig, "disableBaselineCheck", "false"));
        const baselineCheckDelay = Number(_.get(orgConfig, "baselineCheckDelay", 0));
        const daysSinceAcceptedTerms = Moment().diff(Moment(patient.acceptedTerms), 'days', true);

        log.debug("daysSinceAcceptedTerms:", daysSinceAcceptedTerms, patient.acceptedTerms, baselineCheckDelay);
        if (!inConversation && planActive && !disableBaselineCheck && daysSinceAcceptedTerms >= baselineCheckDelay &&
            (lastBaseline === null || !lastBaseline.journal.find((e) => e.eod === true))) {
            let dialog = <Dialog open={true} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                <DialogContent id="baseline-dialog" >
                    <T.span text='checkBaseline' />
                </DialogContent>
                <DialogActions>
                    <Button id="baselineCancel" color="primary" variant="contained"
                        onClick={this.closeDialog.bind(this)}><T.span text='cancel' /></Button>
                    <Button id="baselineYes" color="primary" variant="contained" component={Link} to='/baseline'
                        onClick={this.closeDialog.bind(this)}><T.span text='yes' /></Button>
                </DialogActions>
            </Dialog>;

            this.setState({ dialog });
        }
        else {
            // found a baseline, check for a daily check-in now..
            this.checkDaily();
        }
    }

    checkDaily() {
        const { org, patient, planActive } = this.state;
        const { lastCheckInAlert } = this.state.patient;

        const inConversation = window.location.pathname.endsWith('/conversation');          // we don't display the checkDaily if they are already checking in
        const orgConfig = _.get(org, "config") || {};
        const disableDailyCheck = toBoolean(_.get(orgConfig, "disableDailyCheck", "false"));

        let checkInPrompt = !lastCheckInAlert;
        if (planActive && lastCheckInAlert && lastCheckInAlert.data) {
            let overallAlert = lastCheckInAlert.data[0];
            let endOfDay = Moment(lastCheckInAlert.eventTime).endOf('day').toDate();
            let checkInToday = Moment() < endOfDay;
            log.info(`checkInToday: ${checkInToday}, endOfDay: ${endOfDay.toISOString()}, overallAlert: ${overallAlert}`);
            // save the sessionId, if the last check-in was on the same day
            if (checkInToday) {
                this.setState({ lastSessionId: lastCheckInAlert.sessionId });
            } else {
                checkInPrompt = true;
            }
        }

        if (!inConversation && planActive && checkInPrompt && !disableDailyCheck && patient.inactive !== true) {
            let dialog = <Dialog open={true} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                <DialogContent id="checkDaily-dialog" style={{ marginBottom: 0 }}>
                    <div style={{ marginRight: 10, float: 'left' }}><ScheduleRoundedIcon style={{ fontSize: '48' }} /></div>
                    <div style={{ marginTop: 5, textAlign: 'justify' }}><T.span text='checkDaily' /></div>
                </DialogContent>
                <DialogActions>
                    <Button id="checkDailyCancel" color="primary" variant="contained" onClick={this.closeDialog.bind(this)}><T.span text='no' /></Button>
                    <Button id="checkDailyYes" color="primary" variant="contained" component={Link} to='/conversation' onClick={() => {
                        log.metric({ EventName: 'PatientAction', Action: 'promptedCheckIn', count: 1 })
                        this.closeDialog();
                    }}><T.span text='yes' /></Button>
                </DialogActions>
            </Dialog>;
            this.setState({ dialog });
        }
    }

    onRejectedTerms() {
        log.debug("onRejectedTerms()");
        this.closeDialog();
        this.confirmSignOut();
    }

    onAcceptedTerms() {
        this.closeDialog();

        log.debug("Setting termsAccepted to true");
        this.setState({ termsAccepted: true }, this.autoStartCheckIn.bind(this));
    }

    autoStartCheckIn() {
        // if the URL provided ?models=A,B,C, drop the patient straight into a check-in for those models
        // (e.g. provider sends a link to start a PHQ-4); the models prop is forwarded to the back-end via
        // ConversationView's resetConversation. Cleared in onConversationDone/onConversationCancel so it
        // only fires once per session.
        if (this.state.models) {
            log.info("auto-starting check-in with models:", this.state.models);
            this.setState(
                { dialog: <Redirect to='/conversation' /> },
                () => this.setState({ dialog: null })
            );
        } else if (this.state.openComponent) {
            // ?openComponent=<Name> — open a registered dialog directly. Cleared on close.
            this.openRegisteredComponent(this.state.openComponent);
        } else {
            this.checkTutorial();
        }
    }

    openRegisteredComponent(name) {
        const Component = getComponent(name);
        if (!Component) {
            log.warning(`openRegisteredComponent: unknown component "${name}"`);
            this.setState({ openComponent: null });
            return;
        }
        log.info(`openRegisteredComponent: opening "${name}"`);
        const closeDialog = () => this.setState({ dialog: null, hideMessages: false, openComponent: null });
        const source = [{ origin: isReactNative() ? 'patient-mobile-client' : 'patient-web-client' }];
        this.setState({
            hideMessages: true,
            dialog: <Component
                appContext={this}
                patientId={this.state.patientId}
                open={true}
                source={source}
                onClose={closeDialog}
            />
        });
    }

    onSignIn(login) {
        const { username, refreshToken, idToken, userId } = login;

        if (this.signoutTimer) {
            clearTimeout(this.signoutTimer);
            this.signoutTimer = null;
        }

        log.update({ idToken, userId });
        this.postMessage({ action: 'onRefreshToken', username, refreshToken });
        this.setState({ userId });      
        this.getSelf();
        this.initializeMenu();
    }

    initializeMenu() {
        if (!this.isCompactDisplay() && !this.state.menu)
            this.onToggleMenu();
    }

    onSignOut() {
        log.debug("onSignOut()", this);
        this.setState({
            dialog: <Dialog model="false" open={true} onClose={() => this.closeDialog()} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                <DialogTitle><SignOutIcon style={{ float: 'left', marginRight: 5 }} /><T.span text="signOut" /></DialogTitle>
                <DialogContent id="areYouSureSignout" >
                    <DialogContentText><T.span text="areYouSureSignout" /></DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id="signoutCancel" color="primary" variant="contained" style={styles.button} onClick={this.closeDialog.bind(this)} ><T.span text="cancel" /></Button>
                    <Button id="signoutConfirm" color="primary" variant="contained" style={styles.button} onClick={this.confirmSignOut.bind(this)}><T.span text="confirm" /></Button>
                </DialogActions>
            </Dialog>
        });
    }

    closeDialog() {
        log.debug("closeDialog");
        this.setState({ dialog: null });
    }

    onSignoutTimer = () => {
        log.debug("onSignoutTimer()");
        if (this.signoutTimer) {
            clearTimeout(this.signoutTimer);
            this.signoutTimer = null;
        }
        log.update({ idToken: null, userId: null, requestId: null });
    }

    confirmSignOut() {
        log.debug("confirmSignOut:", this);
        // after some time, clear the idToken from the logger so we will stop sending logs/metrics to the back-end
        this.signoutTimer = setTimeout(this.onSignoutTimer, LOG_TIMEOOUT_MS);

        clearInterval(this.intervalTimer);
        sessionStorage.removeItem('idToken');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('userId');

        this.setState({
            username: '',
            patientId: '',
            idToken: null,
            refreshToken: null,
            dialog: null,
            termsAccepted: false,
            configLoaded: false,
            textLoaded: false,
            alertLevelsLoaded: false,
            providerLoaded: false,
            orgLoaded: false,
            idleDialog: null
        });
    }

    refreshMenu() {
        // The drawer JSX is now rebuilt in render(), not cached. This method
        // is kept as a no-op so existing callers don't break; visibility is
        // controlled by state.menu (boolean).
    }

    onToggleMenu(e) {
        // state.menu is a boolean flag: true → drawer visible, false → hidden.
        // The actual drawer JSX is built fresh in render via getMenu() so it
        // always reflects the latest state (patient, org, route).
        this.setState({ menu: !this.state.menu, leftNavOpen: !this.state.menu && !this.isCompactDisplay() });
    }

    onCall(phoneNumbers) {
        if (isArrayValid(phoneNumbers)) {
            let dialog = <Dialog open={true} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                <DialogTitle id="call-dialog-title" style={{ margin: 0, textAlign: 'left', background: '#808080', padding: 10 }}>
                    <T.span style={{ margin: 5, fontSize: 20, color: '#ffffff' }} text='callInstructions' />
                </DialogTitle>
                <List>
                    {phoneNumbers.map((phoneNumber) => {
                        const number = Phone(phoneNumber.number);
                        log.debug("number:", number);
                        if (number.isValid) {
                            if (phoneNumber.name === undefined) phoneNumber.name = phoneNumber.numberType;
                            return <ListItem key={phoneNumber.name} style={{ textAlign: "left" }}>
                                <ListItemAvatar>
                                    <Avatar style={{ backgroundColor: '#eeeeee' }}>
                                        <CallIcon style={{ color: '#808080' }} />
                                    </Avatar>
                                </ListItemAvatar>
                                <Button id="phoneNumber" style={{ display: "block", textAlign: 'left' }} color="primary"
                                    onClick={() => {
                                        this.onURL({ href: `tel://${number.phoneNumber}` });
                                        this.setState({ openDialog: null })
                                    }}>{phoneNumber.name + ": " + number.phoneNumber}</Button>
                            </ListItem>
                        } else {
                            return null;
                        }
                    })}
                </List>
                <DialogActions>
                    <Button id="phoneCancel" variant="contained" color="primary" onClick={() => this.setState({ openDialog: null })}><T.span style={{ fontSize: 14 }} text='cancel' /></Button>
                </DialogActions>
            </Dialog>;
            this.setState({ openDialog: dialog });
        }
    }

    onURL(url) {
        log.debug("onURL:", url);
        let urlParts = new URL(url.href);
        log.debug("urlParts:", urlParts);

        function sameOrigin() {
            let protocol = urlParts.protocol.toLowerCase();
            if (protocol === 'mailto:' || protocol === 'tel:') {
                return true;
            }
            let host = urlParts.host;
            if (!host) {
                // If URI is not absolute or protocol-relative then it is always same-origin
                return true;
            }
            return window.location.host === host;
        }

        if (!sameOrigin()) {
            log.debug("!sameOrigin()");
            let description = url.description ? T.texts[url.description] : '';
            if (isHTML(description))
                description = <div ref={this.hookDiv} dangerouslySetInnerHTML={{ __html: description }} />;
            else
                description = <div>{description}<br /><br /></div>;

            let openDialog = <Dialog open={true} fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}>
                <DialogContent>{description}{url.disableWarning !== true ? <T.span text='urlWarning' /> : null}</DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={this.onCancelURL.bind(this)}><T.span text='cancel' /></Button>
                    <Button color="primary" onClick={this.onOpenURL.bind(this, url)}><T.span text='ok' /></Button>
                </DialogActions>
            </Dialog>;

            this.setState({ openDialog });
        }
        else {
            let protocol = urlParts.protocol.toLowerCase();
            log.debug("protocol:", protocol);
            if (protocol === 'mailto:' || protocol === 'tel:') {
                this.onOpenURL(url);
            }
            else {
                // same origin, so just open the URL with a redirect..
                let pathname = urlParts.pathname;
                this.setState({ dialog: <Redirect to={pathname} /> }, () => this.setState({ dialog: null }));
            }
        }
    }

    onOpenURL(url) {
        if (isReactNative()) {
            this.postMessage({ action: 'onOpenURL', url });
        } else {
            window.open(url.href, "_blank");
        }
        this.onCancelURL();
    }

    onOpenFile(url) {
        if (isReactNative()) {
            this.postMessage({ action: 'onOpenURL', url });
        } else {
            window.open(url.href, "_blank");
        }
    }

    onCancelURL() {
        this.setState({ openDialog: null });
    }

    getMenu() {
        const { classes } = this.props;
        const { config, providerPhones, org, orgPhones, surveys, trials, messageCount, patient, planActive } = this.state;
        const newTrials = (trials || []).filter((e) => e.new);

        const logMetric = (metric) => () => {
            log.metric({ EventName: 'PatientAction', Action: metric, count: 1 })
        }
        const menu = _.get(config, "menu") || { "signOut": true };
        const orgConfig = _.get(org, "config") || {};
        const MENU_ITEMS = {
            "dashboard": <MenuItem id="dashboardMenu" key='dashboard' component={NavLink} to="/dashboard" activeClassName="Mui-selected" onClick={logMetric('home')}>
                <ListItemIcon className={classes.icon}><DashboardIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="dashboard" />} />
            </MenuItem>,
            "conversation": <MenuItem id="check-inMenu" metric='checkIn' key='conversation' disabled={isDisabled(menu, 'conversation') || !planActive || (patient && patient.inactive === true)}
                onClick={logMetric('checkIn')}
                component={NavLink} to="/conversation" activeClassName="Mui-selected">
                <ListItemIcon className={classes.icon}><ConversationIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="conversation" />} />
            </MenuItem>,
            "surveys": <MenuItem id="surveysMenu" key='surveys' disabled={isDisabled(menu, 'surveys')} component={NavLink} to="/surveys" activeClassName="Mui-selected" onClick={logMetric('surveys')}>
                <ListItemIcon className={classes.icon}>
                    <Badge invisible={surveys.length === 0} color='secondary' overlap="circular" badgeContent={`${surveys.length}`}>
                        <SurveysIcon />
                    </Badge>
                </ListItemIcon>
                <ListItemText primary={<T.span text="surveys" />} />
            </MenuItem>,
            "trials": <MenuItem id="trialsMenu" key='trials' disabled={isDisabled(menu, 'trials')} component={NavLink} to="/trials" activeClassName="Mui-selected" onClick={logMetric('trials')}>
                <ListItemIcon className={classes.icon}>
                    <Badge invisible={newTrials.length === 0} color='secondary' overlap="circular"
                        badgeContent={`${newTrials.length}`}>
                        <TrialsIcon />
                    </Badge>
                </ListItemIcon>
                <ListItemText primary={<T.span text="trials" />} />
            </MenuItem>,
            "medications": <MenuItem id="medicationsMenu" key='medications' disabled={isDisabled(menu, 'medications')} component={NavLink} to="/medications" activeClassName="Mui-selected" onClick={logMetric('medications')}>
                <ListItemIcon className={classes.icon}><MedicationsIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="medications" />} />
            </MenuItem>,
            "vaccinations": <MenuItem id="vaccinationsMenu" key='vaccinations' disabled={isDisabled(menu, 'vaccinations')} component={NavLink} to="/vaccinations" activeClassName="Mui-selected" onClick={logMetric('vaccinations')}>
                <ListItemIcon className={classes.icon}><VaccinationIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="vaccinations" />} />
            </MenuItem>,
            "activity": <MenuItem id="activityMenu" key='activity' disabled={isDisabled(menu, 'activity')} component={NavLink} to="/activity" activeClassName="Mui-selected" onClick={logMetric("activity")}>
                <ListItemIcon className={classes.icon}><NetworkCheckIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="activity" />} />
            </MenuItem>,
            "test": <MenuItem key='testMenu' disabled={isDisabled(menu, 'test')} component={NavLink} to="/test" activeClassName="Mui-selected" onClick={logMetric('testResults')}>
                <ListItemIcon className={classes.icon}><AddBoxIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="test" />} />
            </MenuItem>,
            "resources": <MenuItem id="resourcesMenu" key='resources' disabled={isDisabled(menu, 'resources')} component={NavLink} to="/resources" activeClassName="Mui-selected" onClick={logMetric('resources')}>
                <ListItemIcon className={classes.icon}><SunIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="resources" />} />
            </MenuItem>,
            "clearance": <MenuItem id="quarantine-isolationMenu" key='clearance' disabled={isDisabled(menu, 'clearance')} component={NavLink} to="/clearance" activeClassName="Mui-selected" onClick={logMetric('clearance')}>
                <ListItemIcon className={classes.icon}><ClearanceIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="clearance" />} />
            </MenuItem>,
            "report": <MenuItem id="reportMenu" disabled={isDisabled(menu, 'report')} key='report' component={NavLink} to="/report" activeClassName="Mui-selected" onClick={logMetric('eReport')}>
                <ListItemIcon className={classes.icon}><ReportIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="report" />} />
            </MenuItem>,
            "profile": <MenuItem id="profileMenu" disabled={isDisabled(menu, 'profile')} key='profile' component={NavLink} to="/profile" activeClassName="Mui-selected" onClick={logMetric('profile')}>
                <ListItemIcon className={classes.icon}><ProfileIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="profile" />} />
            </MenuItem>,
            "messages": <MenuItem id="messagesMenu" disabled={isDisabled(menu, 'messages')} key='messages' component={NavLink} to="/messages" activeClassName="Mui-selected" onClick={logMetric('messages')}>
                <ListItemIcon className={classes.icon}>
                    <Badge invisible={messageCount === 0} color='secondary' overlap="circular" badgeContent={`${messageCount}`}>
                        <MessagesIcon />
                    </Badge>
                </ListItemIcon>
                <ListItemText primary={<T.span text="messages" />} />
            </MenuItem>,
            "appointments": <MenuItem id="appointmentsMenu" disabled={isDisabled(menu, 'appointments')} key='appointments' component={NavLink} to="/appointments" activeClassName="Mui-selected" onClick={logMetric('appointments')}>
                <ListItemIcon className={classes.icon}><AppointmentsIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="appointments" />} />
            </MenuItem>,
            "education": <MenuItem id="educationMenu" disabled={isDisabled(menu, 'education')} key='education' component={NavLink} to="/education" activeClassName="Mui-selected" onClick={logMetric('education')}>
                <ListItemIcon className={classes.icon}><EducationIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="education" />} />
            </MenuItem>,
            "videoChat": <MenuItem id="videoChatMenu" disabled={isDisabled(menu, 'videoChat')} key='video' component={NavLink} to="/video" activeClassName="Mui-selected" onClick={logMetric('videoChat')}>
                <ListItemIcon className={classes.icon}><VideoIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="videoConf" />} />
            </MenuItem>,
            "callDr": <MenuItem id="callDrMenu" disabled={isDisabled(menu, 'callDr') || !isArrayValid(providerPhones)} key='callDr'
                onClick={() => {
                    logMetric('callDr')();
                    this.onCall(providerPhones)
                }}>
                <ListItemIcon className={classes.icon}><CallIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="callDr" />} />
            </MenuItem>,
            "callOrg": <MenuItem id="callOrgMenu" disabled={isDisabled(menu, 'callOrg') || !isArrayValid(orgPhones)} key='callOrg'
                onClick={() => {
                    logMetric('callOrg')();
                    this.onCall(orgPhones)
                }
                }>
                <ListItemIcon className={classes.icon}><CallIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="callOrg" />} />
            </MenuItem>,
            "information": <MenuItem id="informationMenu" disabled={isDisabled(menu, 'information') || this.state.faq.length === 0} key='faq' component={NavLink} to="/faq" activeClassName="Mui-selected" onClick={logMetric('information')}>
                <ListItemIcon className={classes.icon}><FAQIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="faq" />} />
            </MenuItem>,
            "companyPolicy": <MenuItem id="policyMenu" disabled={isDisabled(menu, 'companyPolicy') || this.state.companyPolicy.length === 0} key='companyPolicy' component={NavLink} onClick={logMetric('companyPolicy')}
                to="/companyPolicy" activeClassName="Mui-selected" >
                <ListItemIcon className={classes.icon}><FAQIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="companyPolicy" />} />
            </MenuItem>,
            "emlife": <MenuItem id="emlifeMenu" disabled={isDisabled(menu, 'emlife')} key='emlife'
                onClick={() => {
                    logMetric('emlife')();
                    this.onURL(getSettings(menu, 'emlife'))
                }}>
                <ListItemIcon><WebIcon /></ListItemIcon>
                <ListItemText primary={<T.span text={_.get(menu, "emlife.title")} />} />
            </MenuItem>,
            "feedback": <MenuItem id="feedbackMenu" disabled={isDisabled(menu, 'feedback')} key='feedback' component={NavLink} to="/feedback" activeClassName="Mui-selected" onClick={logMetric('feedback')}>
                <ListItemIcon className={classes.icon}><FeedbackIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="feedback" />} />
            </MenuItem>,
            "settings": <MenuItem id="settingsMenu" key='settings' component={NavLink} to="/settings" activeClassName="Mui-selected" onClick={logMetric('settings')}>
                <ListItemIcon className={classes.icon}><SettingsIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="settings" />} />
            </MenuItem>,
            "history": <MenuItem id="historyMenu" key='history' component={NavLink} to="/history" activeClassName="Mui-selected" onClick={logMetric('history')}>
                <ListItemIcon className={classes.icon}><HistoryIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="history" />} />
            </MenuItem>,
            "signOut": <MenuItem id="signoutMenu" key='signout' onClick={(e) => { logMetric('signout'); this.onSignOut(); }}>
                <ListItemIcon className={classes.icon}><SignOutIcon /></ListItemIcon>
                <ListItemText primary={<T.span text="signOut" />} />
            </MenuItem>
        };

        // Items live in two groups in the drawer: Primary (home/messages/etc.)
        // at the top and Utility (profile/feedback/settings/signOut) at the
        // bottom, separated by a divider. Anything not listed in UTILITY_KEYS
        // defaults to Primary. Order within each group respects the org's
        // `menu` config key order.
        const UTILITY_KEYS = new Set(['profile', 'feedback', 'settings', 'signOut']);
        const primaryItems = [];
        const utilityItems = [];
        for (let k in menu) {
            if (!isVisible(this, menu, orgConfig, k)) continue;
            (UTILITY_KEYS.has(k) ? utilityItems : primaryItems).push(MENU_ITEMS[k]);
        }

        const logoSrc = this.getLogo();
        const logoAlt = org ? org.name + " Logo" || "Apricity Logo" : "Apricity Logo";

        // User context block — appears between the logo and the menu items.
        // For clock cohort orgs, patient.studyId / patient.studyTrack render as
        // pills next to the name. Oncology orgs (no study fields) just show the
        // patient name.
        const userName = patient ? `${patient.firstName || ''} ${patient.lastName || ''}`.trim() : '';
        const studyId = patient && patient.studyId;
        const studyTrack = patient && patient.studyTrack;
        const accentTint = hexToRgba(this.theme.palette.secondary && this.theme.palette.secondary.main, 0.15);
        const accentColor = (this.theme.palette.secondary && this.theme.palette.secondary.main) || '#666666';
        const userContextBlock = userName ? (
            <div style={{
                padding: `${tokens.space[3]}px ${tokens.space[4]}px`,
                borderBottom: `1px solid ${tokens.border.tertiary}`,
            }}>
                <div style={{ fontSize: tokens.type.body.fontSize, fontWeight: 500, color: this.theme.palette.text.primary }}>
                    {userName}
                </div>
                {(studyId || studyTrack) && (
                    <div style={{ marginTop: tokens.space[1], display: 'flex', gap: tokens.space[1], flexWrap: 'wrap' }}>
                        {studyId && (
                            <span style={{
                                fontSize: tokens.type.caption.fontSize,
                                fontWeight: 500,
                                padding: `${tokens.space[1]}px ${tokens.space[2]}px`,
                                borderRadius: tokens.radius.full,
                                background: accentTint,
                                color: accentColor,
                            }}>{studyId}</span>
                        )}
                        {studyTrack && (
                            <span style={{
                                fontSize: tokens.type.caption.fontSize,
                                fontWeight: 500,
                                padding: `${tokens.space[1]}px ${tokens.space[2]}px`,
                                borderRadius: tokens.radius.full,
                                background: accentTint,
                                color: accentColor,
                            }}>{studyTrack}</span>
                        )}
                    </div>
                )}
            </div>
        ) : null;

        // Width follows the tier: tablet is intentionally narrower (220) than
        // desktop (240) because tablet portrait has less horizontal room; mobile
        // gets the widest (280) because the drawer is an overlay anyway.
        const drawerWidth = this.isMobile() ? 280 : (this.isTablet() ? 220 : 240);

        let menuItem = <ClickAwayListener onClickAway={() => {
            if (this.isCompactDisplay())
                this.onToggleMenu();
        }}>
            <Drawer className="app-sidebar" PaperProps={{ style: { width: drawerWidth } }} variant="persistent" open={true}>
                <div align="left">
                    {/* Logo zone — uses logoBackgroundColor (per-org or theme
                        default) so logos with dark glyphs read against a light
                        backdrop even in dark themes. The user context block
                        renders separately below on the drawer's own surface so
                        white-on-dark text isn't washed out by the light logo
                        backdrop. */}
                    <div style={{ backgroundColor: _.get(orgConfig, 'logoBackgroundColor') || _.get(this.theme, 'logoBackgroundColor') || 'transparent' }}>
                        <div style={styles.sidebarHeader}>
                            <img style={styles.logo} src={logoSrc} alt={logoAlt} />
                        </div>
                    </div>
                    {userContextBlock}
                    <MenuList style={{ paddingBottom: '60px' }} onClick={() => {
                        // Close the drawer on tap whenever it's an overlay
                        // (compact display) so the selected route's content
                        // is visible immediately while it loads, instead of
                        // requiring a second tap on the hamburger / outside
                        // the drawer.
                        if (this.isCompactDisplay() && this.state.menu) {
                            this.setState({ menu: false, leftNavOpen: false });
                        }
                    }}>
                        {primaryItems}
                        {primaryItems.length > 0 && utilityItems.length > 0 && (
                            <Divider key="nav-divider" style={{ margin: `${tokens.space[2]}px ${tokens.space[4]}px` }} />
                        )}
                        {utilityItems}
                    </MenuList>
                    <div style={{ ...styles.sidebarFooter, width: drawerWidth - 5 }}>
                        {toBoolean(_.get(this.state, 'org.config.showPoweredBy'), true) && <T.span text={{ key: 'menuFooter', year: Moment().year() }} />}
                    </div>
                </div>
            </Drawer>
        </ClickAwayListener>;

        return menuItem;
    }

    onRegisterDone(login) {
        const { username, userId, idToken, refreshToken } = login;
        log.debug("onRegisterDone:", login);
        sessionStorage.setItem('username', username);
        sessionStorage.setItem('userId', userId);
        sessionStorage.setItem('idToken', idToken);
        sessionStorage.setItem('refreshToken', refreshToken);
        this.postMessage({ action: 'onRefreshToken', username, refreshToken });

        if (login.country !== 'US') {
            this.onSetTemperatureUnit('C');     // default to C for everyone except the US
        }

        log.update({ idToken, userId });
        this.setState({
            dialog: null,
            username,
            idToken,
            refreshToken,
            userId,
            registerDone: true
        });
        this.getSelf();
        this.initializeMenu();
    }

    onRegister(opts) {
        let { domainOrg, defaultPlanId, defaultProviderId } = this.state;
        let query = getQuery();
        let providerId = query.get('providerId') || defaultProviderId;
        let planId = query.get('planId') || defaultPlanId || Config.defaultPlanId;
        let registrationCode = query.get('registrationCode') || undefined;

        log.debug(`onRegister providerId: ${providerId}, planId: ${planId}`);
        this.setState({
            dialog: <CreateAccountDialog appContext={this} planId={planId} providerId={providerId} org={domainOrg} registrationCode={registrationCode}
                opts={opts} onCancel={this.closeDialog.bind(this)} onDone={this.onRegisterDone.bind(this)} />
        });
    }

    getLogo() {
        const logoOverride = localStorage.getItem('logoOverride');
        const defaultLogo = getAppName();
        const logo = logoOverride || defaultLogo;

        switch (logo) {
            case 'Apricity@Work':
                return ApricityWorkLogo;
            case 'ApricityCare':
                return ApricityCareLogo;
            default:
                if ( logo.startsWith("https://") || logo.startsWith("http://") )
                    return logo;
                return ApricityCareLogo;
        }
    }

    getResetPassword(username) {
        if (this._resetPassword !== true) {
            this._resetPassword = true;
            const resetPassword = {
                url: Config.baseUrl + `${Config.pathPrefix}anon/authentication/resetPassword`,
                method: 'POST',
                data: {
                    username
                }
            }
            log.debug("resetPassword request:", resetPassword);
            AxiosRequest(resetPassword).then((result) => {
                log.debug("resetPassword result:", result.data);
                this.setState({ resetPassword: true });
            }).catch((err) => {
                this.setState({ resetPasswordError: getErrorMessage(err) });
                log.error("resetPassword error:", err);
            })
        }

        if (this.state.resetPassword === true) {
            return <div className='App-loading'><T.span text='passwordReset' /></div>;
        } else if (this.state.resetPasswordError) {
            return <div className='App-loading'><span style={{ color: 'red' }}>{this.state.resetPasswordError}</span></div>
        } else {
            return <div className="App-loading"><CircularProgress /></div>;
        }
    }

    getValidateEmail(email, validationCode) {
        if (this._validatingEmail !== true) {
            this._validatingEmail = true;
            const validateEmail = {
                url: Config.baseUrl + `${Config.pathPrefix}anon/authentication/emailValidate`,
                method: 'POST',
                data: {
                    email,
                    validationCode
                }
            }
            log.debug("emailValidate request:", validateEmail);
            AxiosRequest(validateEmail).then((result) => {
                log.debug("emailValidate result:", result.data);
                this.setState({ emailValidated: true });
            }).catch((err) => {
                this.setState({ validateError: getErrorMessage(err) })
                log.error(err);
            })
        }

        if (this.state.emailValidated === true) {
            return <div className='App-loading'><T.span text='emailValidated' /></div>;
        } else if (this.state.validateError) {
            return <div className='App-loading'><span style={{ color: 'red' }}>{this.state.validateError}</span></div>
        } else {
            return <div className="App-loading"><CircularProgress /></div>;
        }
    }

    getLoginView() {
        if (this.state.domainDetected === false) {
            return <div className="App-loading"><CircularProgress /></div>;
        }
        const { dialog, progress, domainOrg, androidLink, iosLink, removeAccount } = this.state;
        const logo = this.getLogo();
        const query = getQuery();
        const email = query.get('email');
        const resetPassword = query.get('resetPassword');
        const validationCode = query.get('validationCode');
        if (email && validationCode) {
            return this.getValidateEmail(email, validationCode);
        } else if (resetPassword) {
            return this.getResetPassword(resetPassword);
        }
        const disableRegister = toBoolean(query.get("disableRegister"))
            || toBoolean(_.get(domainOrg, 'config.disableRegister'));

        const register = removeAccount ? <div align='left' style={{ margin: 15 }} ><b><T.span text='removeAccountInstructions' /></b></div> :
            (domainOrg || query.get('providerId')) && !disableRegister ? <div><Button id="register" variant="contained" style={styles.registerButton}
                onClick={this.onRegister.bind(this)}><T.span text="register" /></Button></div> : null;

        const nativeInstallLinks = !removeAccount && !this.state.isReactNative && (iosLink || androidLink) ?
            <div>
                {androidLink ? <Button onClick={() => window.open(androidLink.url)}><img alt='Android' style={{ width: 150 }} src={AndroidStoreImage} /></Button> : null}
                {iosLink ? <Button onClick={() => window.open(iosLink.url)} ><img alt='iOS' style={{ width: 150 }} src={iOSStoreImage} /></Button> : null}
                <br /><br />
            </div> : null;

        const providedBy = domainOrg ? domainOrg.name : undefined;

        return <div>
            <LoginView
                providedBy={providedBy}
                logo={logo}
                appContext={this}
                group={'patients'}
                onDone={this.onSignIn.bind(this)}
                onSignOut={this.confirmSignOut.bind(this)}
                skipAccount={true}
                register={register}
                onRegisterRequired={this.onRegister.bind(this)}
                federatedLogins={FEDERATED_LOGINS}
                appButtonLinks={nativeInstallLinks} />
            {dialog}
            {progress}
        </div>
    }

    getRemoveAccountView() {
        const { removeAccountConfirmation } = this.state;

        return <Dialog open={true}>
            <DialogTitle><T.span text='removeAccountRequest' /></DialogTitle>
            <DialogContent>
                <T.span text='removeAccountDetails' /><br /><br />
                <div align='center'>
                    <TextField label={T.translate('removeAccountConfirmation')} style={{ margin: 5, width: 400 }} value={removeAccountConfirmation} onChange={(e) => this.setState({ removeAccountConfirmation: e.target.value })} />
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={() => this.setState({ removeAccount: false })}><T.span text='cancel' /></Button>
                <Button variant='contained' disabled={removeAccountConfirmation.toLowerCase().trim() !== 'remove account'} onClick={this.removeAccountConfirmed.bind(this)}><T.span text='removeAccountConfirm' /></Button>
            </DialogActions>
        </Dialog>
    }

    removeAccountConfirmed() {
    }

    getView(view) {
        if (!this.state.idToken) {
            return this.getLoginView();
        }
        // NOTE: Rick didn't want the user to get channeled directly into a dialog to remove their account, so we just display instructions on the login page and that is all.
        // if (this.state.removeAccount) {
        //     return this.getRemoveAccountView();
        // }

        const { classes } = this.props;
        const { maintenance, dialog, openDialog, progress, termsAccepted, configLoaded, textLoaded, alertLevelsLoaded } = this.state;

        // Build the drawer JSX fresh on every render so it picks up changes to
        // patient/org/etc. state.menu is now a boolean visibility flag, not
        // cached JSX — see onToggleMenu / onHandleResize.
        const menu = this.state.menu ? this.getMenu() : null;

        const contentStyle = Object.assign({}, styles.content);
        // Three-tier sidebar: mobile drawer overlays content (no margin),
        // tablet/desktop drawer sits beside it. Widths match getMenu().
        if (!this.isMobile() && this.state.leftNavOpen) {
            contentStyle.marginLeft = this.isTablet() ? 220 : 240;
        }
        if (!termsAccepted || !configLoaded || !textLoaded || !alertLevelsLoaded || !this.state.patientId) {
            //log.debug(`termsAccepted: ${termsAccepted}, configLoaded: ${configLoaded}, textLoaded: ${textLoaded}, alertLevelsLoaded: ${alertLevelsLoaded}, patientId: ${this.state.patientId}`);
            view = <div align='center' style={styles.centeredDiv}><CircularProgress /></div>;
        }

        let homeIcon = <IconButton component={Link} to={'/dashboard'} style={{ color: this.theme.palette.iconColor, paddingTop: 0 }}><HomeIcon /></IconButton>;
        // Hamburger button only — the drawer ({menu}) is rendered as a top-level
        // sibling below, NOT inside the Toolbar. The previous nesting caused a
        // flex-context layout collapse on tall pages (most visible on /profile).
        let hamburgerButton = <IconButton onClick={this.onToggleMenu.bind(this)} style={{ color: this.theme.palette.iconColor, paddingTop: 0 }}><NavigationMenu /></IconButton>;
        let pwaPrompt = isReactNative() ? null : <PWAPrompt promptOnVisit={1} timesToShow={4000} copyClosePrompt="Close" permanentlyHideOnDismiss={true} />;
        const activeMaintenance = maintenance ? maintenance.current || maintenance.upcoming : null;
        let maintenanceMessage = null;
        if (activeMaintenance) {
            maintenanceMessage = <Paper style={{ marginLeft: 25, marginRight: 25, marginTop: 15, marginBottom: 5, textAlign: 'left', background: '#ffc800', padding: 5 }}>
                <AnnouncementIcon style={{ fontSize: 20, float: 'left', padding: 5 }} />
                <Maintenance maintenance={activeMaintenance} />
            </Paper>;
        }

        const accent = (this.theme.palette.secondary && this.theme.palette.secondary.main) || '#666666';
        const headerStyle = {
            height: 56,
            margin: 0,
            position: 'fixed',
            top: 0,
            background: `linear-gradient(${hexToRgba(accent, 0.08)}, ${hexToRgba(accent, 0.08)}), ${this.theme.palette.background ? this.theme.palette.background.paper : '#FFFFFF'}`,
            borderBottom: `1px solid ${hexToRgba(accent, 0.2)}`,
        };
        if (typeof document !== 'undefined') {
            document.documentElement.style.setProperty('--app-accent', accent);
        }
        // Header title — text only. The logo lives in the drawer where
        // branding belongs; the header is purely functional (hamburger / org
        // anchor / home). Avoids the duplicate-logo problem on mobile where
        // the drawer is open at the same time as the header is visible.
        const headerOrgName = (this.state.org && this.state.org.name) || getAppName();
        const headerTitle = (
            <div className={classes.flex} style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: this.isMobile() ? 'center' : 'flex-start',
                paddingLeft: this.isMobile() ? 0 : tokens.space[2],
                fontSize: tokens.type.heading.fontSize,
                fontWeight: tokens.type.heading.fontWeight,
                color: this.theme.palette.text.primary,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}>
                {headerOrgName}
            </div>
        );

        return <div style={contentStyle}>
            {menu}
            <AppBar className="app-header" style={headerStyle} color='inherit' elevation={0}>
                <Toolbar style={{ minHeight: 56 }}>
                    {this.isMobile() && hamburgerButton}
                    {headerTitle}
                    {/*
                      * A centred flex row, not `align="right"`: the home IconButton sets paddingTop: 0 while the agent
                      * trigger uses MUI's default padding, so in a plain block the two sat on different baselines.
                      * Centring on the cross axis makes the group immune to whatever padding each button carries, and
                      * marginLeft:auto is what pushes it right inside the Toolbar's flex.
                      */}
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                        {/*
                          * Ask Apricity (docs/plans/mcp-server.md §4.9, Phase 3).
                          *
                          * Gated per ORGANIZATION and OFF by default: an org decides whether its patients get the agent
                          * at all. It goes in `org.config`, which is where this client already reads its per-org flags
                          * from (disableBaselineCheck, disableDailyCheck, forcedCheckInReminder), rather than inventing a
                          * third place to look. Values there are STRINGS, hence toBoolean.
                          *
                          * 🔒 Richard, 2026-08-21: the key is `enableAskApricity`. Note it breaks the surrounding
                          * `disableX` convention ON PURPOSE — an opt-out flag would default a feature nobody has asked
                          * for to ON for every org.
                          *
                          * Absent rather than disabled, and unknown reads as off: getView() already blocks until
                          * configLoaded/patientId are set, so this never renders before the org config has resolved.
                          *
                          * `context` carries the patient the session is ABOUT — for a delegate that is whoever they
                          * picked in SelectSelf, not themselves. The server treats it as the default subject and still
                          * checks access per call, so it is a focus rather than a fence
                          * 🔒 (Richard: "it doesn't need to be a hard-rule, it can just be a suggestion to the back-end").
                          */}
                        {toBoolean(_.get(this.state.org, 'config.enableAskApricity'), false)
                            && <AIAgent
                                appContext={this}
                                persona="patient"
                                // Match homeIcon beside it exactly. It sets paddingTop: 0, which puts its glyph 18px from
                                // its box top against a default IconButton's 24 — so centring the buttons still left the
                                // sparkle sitting 6px low. Same colour too, so the pair reads as one control group.
                                triggerStyle={{ paddingTop: 0, color: this.theme.palette.iconColor }}
                                context={{ patientId: this.state.patientId }}
                                // Localized, unlike the internal surfaces: these two strings are the only words a
                                // patient reads before they type. They seed from src/locale/*.json and an org can
                                // still override either by textId, the same as every other appText.
                                title={<T.span text='askApricityTitle' />}
                                greeting={<T.span text='askApricityGreeting' />}
                                // No options gear: a patient must not be choosing a model 🔒 Richard, 2026-08-21.
                                showOptions={false}
                                // And no tool-call detail either 🔒 Richard, 2026-08-21. Hiding the gear was not enough:
                                // the remembered preference defaults to ON, so without this a patient would see every
                                // tool name and argument the agent used.
                                allowToolDetail={false}
                                // ...which makes org.config.askApricityModel the ONLY way to set one for them. Blank
                                // falls through to the platform default rather than forcing a stale id.
                                model={_.get(this.state.org, 'config.askApricityModel') || undefined}
                            />}
                        {homeIcon}
                    </div>
                </Toolbar>
            </AppBar>
            <div style={{ paddingTop: 56 }}>
                {pwaPrompt}
                {view}
                {maintenanceMessage}
                {dialog}
                {openDialog}
                {progress}
            </div>
        </div>;
    }

    isSelected(path) {
        let pathname = window.location.pathname.slice(1).split('/');
        pathname = '/' + pathname[0]
        return (path === pathname);
    }

    hookDiv(ref) {
        if (ref) {
            ref.addEventListener('click', (e) => {
                if (e.target.tagName === 'A') {
                    this.onURL({ href: e.target.href });
                    e.preventDefault();
                }
            });
        }
    }

    createAppointment(obj) {
        if (!obj) return;

        const { idToken, org, patientId } = this.state;

        const data = {
            providerId: obj.providerId ? obj.providerId : obj.availableProviderIds && obj.availableProviderIds.length > 0 ? obj.availableProviderIds[0] : org.defaultProviderId,
            patientId,
            start: obj.start,
            end: obj.end,
            originator: 'patient',
            category: 'phone',
            status: 'confirmed'         // IOA-15770: create the appointment as already confirmed, the default is requested.
        };

        log.debug('CreateAppointment', data, obj);

        return new Promise((resolve, reject) => {
            const request = {
                url: Config.baseUrl + `${Config.pathPrefix}orgs/${org.orgId}/appointments/create`,
                method: 'PUT',
                headers: { "Authorization": idToken },
                data
            };
            log.debug("createAppointment request", request);
            AxiosRequest(request).then((response) => {
                log.debug("createAppointment response:", response);
                resolve(response.data.user)
            }).catch((error) => {
                log.debug("createAppointment error:", error.response);
                reject(error)
            });
        });
    }

    onConversationDone(res) {
        log.debug("onConversationDone:", res);
        if (res) {
            const { patientId } = this.state;

            if (!res.bail) {
                addActivity(this, { activityType: 'PatientCheckinCompleted', patientId, description: 'Patient completed check-in.' });
            }
            this.setState({
                dialog: <EodDialog appContext={this} eodResult={res} onClose={() => this.setState({ dialog: null })} />,
                cache: {},
                hardReset: undefined,
                models: null
            });
        } else {
            // if no result, then an error has occured and the covnersation view is ending the conversation..
            this.setState({ models: null, dialog: <Redirect to='/' /> }, () => this.setState({ dialog: null }));
        }
    }

    onConversationCancel() {
        this.setState({
            models: null,
            dialog: <Dialog open={true}>
                <DialogTitle><T.span text='cancelCheckIn' /></DialogTitle>
                <DialogContent><T.span text='confirmCancelCheckIn' /></DialogContent>
                <DialogActions>
                    <Button id='cancel' onClick={() => this.setState({ dialog: null })}><T.span text='cancel' /></Button>
                    <Button id='yes' onClick={() => {
                        log.metric({ EventName: 'PatientAction', Action: 'cancelledCheckIn', count: 1 })
                        this.setState({ dialog: <Redirect to='/' /> }, () => this.setState({ dialog: null }));
                    }}><T.span text='yes' /></Button>
                </DialogActions>
            </Dialog>
        })
    }

    onBaselineDone(completed) {
        const { patientId } = this.state;
        log.debug("onBaselineDone:", completed);

        this.loadBaseline();
        if (completed) {
            addActivity(this, { activityType: 'PatientBaselineCompleted', patientId, description: 'Patient completed baseline.' });
        }
    }

    onActive() {
        log.debug("onActive");
    }

    onIdle() {
        log.debug("onIdle");
        if (this.state.idToken)
            this.setState({ idleDialog: <IdleDialog appContext={this} /> })
    }

    // reload our patient record from the back-end and update our patient state with any changes... 
    reloadPatient() {
        const { idToken, patient, patientId } = this.state;

        const getPatient = {
            url: Config.baseUrl + `${Config.pathPrefix}patients/${patientId}`,
            method: 'GET',
            headers: { "Authorization": idToken }
        };

        log.info("reloadPatient request:", getPatient);
        return AxiosRequest(getPatient).then((result) => {
            log.info("reloadPatient result:", result.data);

            this.setState({ patient: { ...patient, ...result.data.patient } });
        }).catch((err) => {
            log.error("getPatient error:", err);
        })

    }

    updatePatient(updates) {
        const { patient, patientId, idToken } = this.state;
        const sessionIdToken = sessionStorage.getItem('idToken');
        if (!patientId) {
            throw new Error("no valid patientId");
        }
        if (!idToken && !sessionIdToken) {
            throw new Error("no valid idToken");
        }

        let updatePatient = {
            url: Config.baseUrl + `${Config.pathPrefix}patients/${patientId}`,
            method: 'PUT',
            headers: { Authorization: idToken || sessionIdToken },
            data: updates
        };

        // also apply the updates to our local patient record, please note the patient
        // can be null when applying a subscriptionId for example.
        if (patient) {
            for (let k in updates) {
                if (updates[k] !== undefined) {
                    patient[k] = updates[k];
                }
            }
        }

        log.debug('updatePatient request:', updatePatient);
        return AxiosRequest(updatePatient).then((result) => {
            log.debug("updatePatient result:", result.data);
            return result.data.patient;
        }).catch((err) => {
            log.error('updatePatient error:', err);
            throw err;
        })
    }

    getSubscriptionView() {
        const { subscriptionId, patientId, subscriptionError } = this.state;
        const idToken = sessionStorage.getItem('idToken');

        if (!patientId || !idToken || subscriptionError) {
            return <div className="App-loading"><T.span style={{ color: 'red' }} text='subscriptionError' /></div>
        }

        if (this._subscriptionView !== true) {
            this._subscriptionView = true;

            this.updatePatient({ subscriptionId }).then((result) => {
                const { manageUrl } = result.data.patient.subscriptionInfo;
                log.debug('Sending onSubscibed message:', window.parent);
                this.postParentMessage({ action: 'reloadPatient' });

                log.debug("Redirecting to URL:", manageUrl);
                window.location = manageUrl;

            }).catch((err) => {
                log.error('getSubscriptionView error:', err);
                this.setState({ subscriptionError: true });
            });
        }

        return <div className="App-loading"><CircularProgress /></div>;
    }

    getSnackbarMessages() {
        if (!this.state.idToken || this.state.termsAccepted !== true || this.state.dialog !== null || this.state.hideMessages ) {
            // don't display the snackbar until the terms have been accepted and that no other dialog is showing
            return null;
        }
        let messages = [];

        const buttonStyle = { color: 'white' };
        const { patient, hideSubscribeSnackbar, hideReminderSnackbar, hideSurveySnackbar, forcedCheckInReminderMessage, surveys, org = {} } = this.state;
        if (patient && patient.inactive === true && !hideSubscribeSnackbar && (org && org.billingType === 'square') &&
            !toBoolean(_.get(org, 'config.disableSubscribeReminder'), false)) {
            messages.push(<div key='patientSubscribe'>
                <T.span text='patientSubscribe' />
                <Button onClick={() => this.setState({ hideSubscribeSnackbar: true })} style={buttonStyle}><T.span text='dismiss' /></Button>
                <Button onClick={() => this.setState({
                    hideSubscribeSnackbar: true,
                    dialog: <SubscriptionDialog appContext={this} onClose={() => this.setState({ dialog: null })} />
                })}
                    style={buttonStyle}><T.span text='subscribe' /></Button>
            </div>
            );
        }

        const disableCheckInReminder = toBoolean(_.get(org, 'config.disableCheckInReminder'), true);
        const forcedCheckInReminder = toBoolean(_.get(org, 'config.forcedCheckInReminder'), false);
        if (messages.length < 1 && patient && patient.inactive !== true && (patient.reminderEnabled === undefined || patient.reminderEnabled === null) && !hideReminderSnackbar
            && !disableCheckInReminder && !forcedCheckInReminder)  // check the org config, default to this being disabled, unless disableCheckInReminder is really false
        {
            messages.push(<div key='checkinReminder'>
                <T.span text='setupCheckInReminder' />
                <Button onClick={() => {
                    patient.reminderEnabled = false;
                    this.updatePatient({ reminderEnabled: false });
                    this.setState({ hideReminderSnackbar: true })
                }} style={buttonStyle}><T.span text='dismiss' /></Button>
                <Button onClick={() => this.setState({ hideReminderSnackbar: true, dialog: <ReminderDialog appContext={this} onSet={() => this.setState({ dialog: null })} /> })}
                    style={buttonStyle} ><T.span text='setup' /></Button>
            </div>
            )
        }

        if (messages.length < 1 && forcedCheckInReminderMessage) {
            messages.push(<div key='forcedCheckInReminder'>
                <T.span text='forcedCheckInReminderActivated' />
                <Button onClick={() => this.setState({ forcedCheckInReminderMessage: false })} style={buttonStyle}><T.span text='dismiss' /></Button>
                <Button component={Link} to='/profile' onClick={() => this.setState({ forcedCheckInReminderMessage: false })} style={buttonStyle} ><T.span text='profile' /></Button>
            </div>);
        }

        //log.debug("surveys:", surveys );
        if (messages.length < 1 && Array.isArray(surveys) && surveys.length > 0 && !hideSurveySnackbar) {
            messages.push(<div key='surveys'>
                <T.span text='surveysAvailable' />
                <Button onClick={() => this.setState({ hideSurveySnackbar: true })} style={buttonStyle}><T.span text='dismiss' /></Button>
                <Button component={Link} to='/surveys' onClick={() => this.setState({ hideSurveySnackbar: true })} style={buttonStyle} ><T.span text='takeSurvey' /></Button>
            </div>
            )
        }

        //log.debug("snackbarMessages:", messages );
        if (messages.length > 0) {
            return <Snackbar id='snackbar' open={true} style={{ width: '95%', margin: 5 }} autoHideDuration={null}>
                <SnackbarContent message={messages} />
            </Snackbar>;
        }
        return null;
    }

    render() {
        // if we have a subscriptionId in our state, then we need to handle associating a patient with their subscription ID
        if (this.state.subscriptionId) {
            return this.getSubscriptionView();
        }
        // catch the consolidated health parameters in the query string, save them into session storage and remove them from the query
        // otherwise the LoginView will attempt to use them for the federated ID's OAuth..
        if (sessionStorage.getItem('chOAuthState')) {
            const params = new URLSearchParams(window.location.search);
            if (params.has('code') && params.has('state')) {
                sessionStorage.setItem("chCode", params.get('code'));
                sessionStorage.setItem("chState", params.get('state'));

                // remove the code & state from the query string, so the LoginView doesn't try to use them...
                params.delete('code');
                params.delete('state');
                window.location.search = params.toString();     // remove the query strings from the URL..
            }
        }

        // Partner branding is delivered via theme entries under src/themes/<partner>/
        // selected per-org through org.config.themeOverride. The block below
        // layers design-token polish on top of whichever theme is active.
        const themeName = this.state.theme || 'light';
        if (this._themeCacheKey !== themeName) {
            const baseTheme = getTheme(themeName);
            const themePrimary = (baseTheme.palette.primary && baseTheme.palette.primary.main);
            this._cachedTheme = createTheme({
                ...baseTheme,
                overrides: {
                    ...baseTheme.overrides,
                    MuiButton: {
                        ...(baseTheme.overrides && baseTheme.overrides.MuiButton),
                        root: {
                            ...((baseTheme.overrides && baseTheme.overrides.MuiButton && baseTheme.overrides.MuiButton.root) || {}),
                            borderRadius: tokens.radius.md,
                            textTransform: 'none',
                            fontWeight: 500,
                            letterSpacing: 0,
                        },
                    },
                    // Cards / paper surfaces: soft shadow in light mode, subtle
                    // border in dark mode. Replaces the inconsistent inline
                    // borders sprinkled across views.
                    MuiPaper: {
                        ...(baseTheme.overrides && baseTheme.overrides.MuiPaper),
                        rounded: { borderRadius: tokens.radius.lg },
                        elevation1: {
                            boxShadow: baseTheme.palette.type === 'dark'
                                ? 'none'
                                : tokens.shadow.card,
                            border: baseTheme.palette.type === 'dark'
                                ? `1px solid ${tokens.border.tertiary}`
                                : 'none',
                        },
                    },
                    // Switches: branded track when checked, consistent sizing
                    // (40x22 track, 18 thumb) to match the spec.
                    MuiSwitch: {
                        ...(baseTheme.overrides && baseTheme.overrides.MuiSwitch),
                        root: {
                            width: 42,
                            height: 22,
                            padding: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                            margin: tokens.space[1],
                        },
                        switchBase: {
                            padding: 2,
                            '&$checked': {
                                transform: 'translateX(20px)',
                                color: '#FFFFFF',
                                '& + $track': {
                                    backgroundColor: themePrimary,
                                    opacity: 1,
                                    border: 'none',
                                },
                            },
                        },
                        thumb: {
                            width: 18,
                            height: 18,
                            boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
                        },
                        track: {
                            borderRadius: tokens.radius.full,
                            backgroundColor: '#BDBDBD',
                            opacity: 1,
                            transition: 'background-color 150ms ease',
                        },
                    },
                    // Status chips: pill shape, caption weight 500 by default.
                    // Components using <Chip> get the consistent look automatically.
                    MuiChip: {
                        ...(baseTheme.overrides && baseTheme.overrides.MuiChip),
                        root: {
                            borderRadius: tokens.radius.full,
                            height: 22,
                            fontSize: tokens.type.caption.fontSize,
                            fontWeight: 500,
                        },
                    },
                    // Dividers: lighten the default to the tertiary border token
                    // so card sections feel less heavy.
                    MuiDivider: {
                        ...(baseTheme.overrides && baseTheme.overrides.MuiDivider),
                        root: {
                            backgroundColor: tokens.border.tertiary,
                        },
                    },
                },
            });
            this._themeCacheKey = themeName;
        }
        this.theme = this._cachedTheme;
        const { patientId, timezone, config, language, gender, temperatureUnit, idleDialog, hardReset, patient, planActive } = this.state;

        document.body.style = `background-color:${this.theme.palette.backgroundColor}; color: ${this.theme.palette.text.primary};`;

        T.setTexts(this.appTexts[language]);
        // Key the ThemeProvider on the active theme name so that when the
        // org's themeOverride changes (or the user picks a different theme)
        // React remounts the tree, invalidating MUI v4's JSS class cache.
        const themeProviderKey = `theme-${this.state.theme || 'default'}`;
        return <div className="App">
            <IdleTimer onActive={this.onActive.bind(this)} onIdle={this.onIdle.bind(this)} debounce={250} timeout={IDLE_TIMEOUT_MS}>
                <ThemeProvider key={themeProviderKey} theme={this.theme}>
                    <ScrollToTop />
                    <Switch basename="/" >
                        <Route exact path="/" render={() => {
                            if (sessionStorage.getItem('chOAuthState')) {
                                return <Redirect to={'/consolidated-health/callback'} />;
                            }
                            return <>{this.getView(<DashboardView appContext={this} settings={config.dashboard} />)}{this.getSnackbarMessages()}</>;
                        }} />
                        <Route path="/web">
                            {this.getView(<WebView id="webView" appContext={this} />)}
                        </Route>
                        <Route path="/dashboard">
                            {this.getView(<DashboardView id="dashboardView" appContext={this} settings={config.dashboard || {}} />)}
                            {this.getSnackbarMessages()}
                        </Route>
                        <Route path="/consolidated-health/callback">
                            {this.getView(<ConsolidatedHealthCallbackView appContext={this} />)}
                        </Route>
                        <Route path="/resources">
                            {this.getView(<DashboardView id="resourcesView" appContext={this} settings={config.resources || {}}
                                icon={<SunIcon />} color='#ff9604'
                                label={<T.span text='resources' />} />)}
                        </Route>
                        <Route path="/medications">
                            {this.getView(<MedicationsView id="vaccinationsView" appContext={this} settings={config.medications || {}}
                                icon={<MedicationsIcon />} color='#ff9604'
                                label={<T.span text='medications' />} />)}
                        </Route>
                        <Route path="/vaccinations">
                            {this.getView(<VaccinationsView id="vaccinationsView" appContext={this} settings={config.vaccinations || {}}
                                icon={<VaccinationIcon />} color='#ff9604'
                                label={<T.span text='vaccinations' />} />)}
                        </Route>
                        <Route path="/test">
                            {this.getView(<CovidTestsView id="covidTestsView" appContext={this} settings={config.tests || {}}
                                icon={<AddBoxIcon />} color='#ff9604'
                                label={<T.span text='test' />} />)}
                        </Route>
                        <Route path="/report">
                            {this.getView(<ReportView id="reportView" appContext={this}
                                icon={<ReportIcon />} color='#ff9604'
                                label={<T.span text="report" />} />)}
                        </Route>
                        <Route path="/appointments">
                            {this.getView(<AppointmentsView id="appointmentsView" appContext={this}
                                icon={<AppointmentsIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text="appointments" />} />)}
                        </Route>
                        <Route path="/history">
                            {this.getView(<HistoryView id="historyView" appContext={this}
                                icon={<HistoryIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text='history' />} />)}
                        </Route>
                        <Route path="/clearance">
                            {this.getView(<ClearanceView id="quarantine-isolationView" appContext={this} clearanceDays={config.clearanceDays || 14}
                                icon={<ClearanceIcon />} color='#686868'
                                label={<T.span text="clearance" />} />)}
                        </Route>
                        <Route path="/messages">
                            {this.getView(<MessagesView id="messagesView" appContext={this}
                                icon={<MessagesIcon />} color='#02365c'
                                label={<T.span text="messages" />} />)}
                        </Route>
                        <Route path="/video">
                            {this.getView(<VideoChatView id="videoView" appContext={this}
                                icon={<VideoIcon />} color='#402361'
                                label={<T.span text="videoConf" />} />)}
                        </Route>
                        <Route path="/faq">
                            {this.getView(<ContentView id="faqView" appContext={this} content={this.state.faq}
                                icon={<FAQIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text="faq" />} />)}
                        </Route>
                        <Route path="/companyPolicy">
                            {this.getView(<ContentView id="policyView" appContext={this} content={this.state.companyPolicy}
                                icon={<FAQIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text="companyPolicy" />} />)}
                        </Route>
                        <Route path="/feedback">
                            {this.getView(<FeedbackView id="feedbackView" appContext={this}
                                icon={<FeedbackIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text="feedback" />} />)}
                        </Route>
                        <Route path="/hotspots">
                            {this.getView(<HotSpotsView id="hotspotsView" appContext={this}
                                icon={<PinDropRoundedIcon />} color='#d61818'
                                label={<T.span text="hotSpots" />}
                                info={'hotSpotsDescription'} />)}
                        </Route>
                        <Route path="/education">
                            {this.getView(<EducationView id="educationView" appContext={this}
                                icon={<EducationIcon />} color='#d61818'
                                label={<T.span text="education" />} />)}
                        </Route>
                        <Route path="/baseline">
                            {this.getView(<ConversationView
                                id="baselineView"
                                appContext={this}
                                baseline={true}
                                persist={true}
                                disableHistory={true}
                                hideRestart={true}
                                disabled={!planActive}
                                source={[{ client: isReactNative() ? 'patient-mobile-client' : 'patient-web-client' }]}
                                clientId={getClientId()}
                                patientId={patientId}
                                language={language}
                                gender={gender}
                                timezone={timezone}
                                temperatureUnit={temperatureUnit}
                                onPostDone={this.onBaselineDone.bind(this)}
                            />)}
                        </Route>
                        <Route path="/surveys" render={(routeProps) => (
                            this.getView(<SurveyView
                                id="surveyView"
                                appContext={this}
                                patientId={patientId}
                                language={language}
                                timezone={timezone}
                                temperatureUnit={temperatureUnit}
                                history={routeProps.history}
                                onDone={this.getPatientSurveys.bind(this)}
                            />)
                        )}>
                        </Route>
                        <Route path="/trials" render={(routeProps) => (
                            this.getView(<TrialsView
                                id="trialsView"
                                appContext={this}
                                patientId={patientId}
                                language={language}
                                timezone={timezone}
                                onDone={this.getPatientTrials.bind(this)}
                            />)
                        )}>
                        </Route>
                        <Route path="/conversation">
                            {this.getView(<div>
                                <ConversationView id="conversationView" appContext={this}
                                    disableHistory={true}
                                    hideRestart={true}
                                    disabled={!patient || patient.inactive || !planActive}
                                    source={[{ client: isReactNative() ? 'patient-mobile-client' : 'patient-web-client' }]}
                                    clientId={getClientId()}
                                    hardReset={hardReset}
                                    patientId={patientId}
                                    models={this.state.models || undefined}
                                    language={language}
                                    gender={gender}
                                    temperatureUnit={temperatureUnit}
                                    ref={(conversationView) => window.conversationView = conversationView}
                                    symptomTracking={config.symptomTracking}
                                    timezone={timezone}
                                    onDone={this.onConversationDone.bind(this)}
                                    onCancel={this.onConversationCancel.bind(this)}
                                    icon={<CheckInIcon />} color='#51cc42'
                                    label={<T.span text="conversation" />}
                                    disclaimer={'disclaimer'}
                                    userType={this.state.userType}
                                /></div>)}
                        </Route>
                        <Route path="/settings">
                            {this.getView(<SettingsView id="settingsView" appContext={this}
                                icon={<SettingsIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text="settings" />} />)}
                        </Route>
                        <Route path="/profile">
                            {this.getView(<ProfileView id="profileView" appContext={this}
                                onMount={this.loadBaseline.bind(this)}
                                icon={<ProfileIcon />} color={this.theme.palette.primary.main}
                                label={<T.span text="profile" />} />)}
                        </Route>
                        <Route path="/">
                            {this.getView(<DashboardView appContext={this} settings={config.dashboard} />)}
                            {this.getSnackbarMessages()}
                        </Route>
                    </Switch>
                    {idleDialog}
                </ThemeProvider>
            </IdleTimer>
        </div>;
    }
}


export function saveUser(idToken, user) {
    return new Promise((resolve, reject) => {
        const request = {
            url: Config.baseUrl + `${Config.pathPrefix}authentication/users/`,
            data: user,
            method: 'POST',
            headers: { "Authorization": idToken }
        };
        log.debug("saveUser request", request);
        AxiosRequest(request).then((response) => {
            log.debug("saveUser response:", response.data);
            resolve(response.data.user)
        }).catch((error) => {
            log.debug("saveUser error:", error.response);
            resolve({})
        });
    });
}

const styles = {
    footer: {
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        paddingLeft: 10,
        paddingBottom: 10,
        textAlign: 'center'
    },
    registerButton: {
        //backgroundColor: '#ffffff',
        borderColor: 'green',
        margin: 15,
        width: 250
    },
    button: {
        margin: 10
    },
    call: {
        margin: 16,
        color: '#000000'
    },
    div: {
    },
    content: {
        overflow: 'hidden',
        transition: 'margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)'
    },
    flex: {
        flex: 1,
    },
    drawerPaper: {
        width: 256,
    },
    logo: {
        width: '90%',
        maxWidth: '300px',
    },
    sidebarHeader: {
        padding: '10px 10px 0 10px',
        textAlign: 'center'
    },
    sidebarFooter: {
        position: 'fixed',
        left: 0,
        bottom: 0,
        // width is set inline at render time to match the drawer width per tier
        fontStyle: 'italic',
        fontSize: tokens.type.caption.fontSize,
        paddingLeft: tokens.space[1],
        paddingBottom: tokens.space[1],
    },
    innerConversation: {
        padding: 10
    },
    eodDisclaimer: {
        marginBottom: 10,
    },
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    centeredDiv: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    }
};


App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
